/* eslint-disable max-len */
export const dashboardProjectData = {
  id: '00000000-0000-0000-0000-000000000000', // DONE
  name: 'Demo Project', // DONE
  description: "Here's a demo project that we ran on Medium's website", // DONE
  testType: 'unmoderated', // DONE
  participantsSource: 'playbook',
  createdAt: '2019-06-20T21:00:00Z', // DONE
  status: 'done', // DONE
  participantsLanguage: 'en-US',
  device: 'computer',
  createdBy: { // DONE
    id: '94710f06-d86d-4d1e-8ad3-71ec21608e7a',
    profile: {
      id: '680bd471-4b09-4427-be61-31273ac79538',
      firstName: 'PlaybookUX',
      lastName: '',
    },
  },
};

export const projectData = {
  id: '00000000-0000-0000-0000-000000000000', // DONE
  name: 'Demo Project', // DONE
  description: "Here's a demo project that we ran on Medium's website", // DONE
  testType: 'unmoderated', // DONE
  status: 'done', // DONE
  createdAt: '2019-06-20T21:00:00Z', // DONE
  studyContext: null, // DONE
  participantsSource: 'playbook',
  participantsLanguage: 'en-US',
  company: {
    id: '00000000-0000-0000-0000-000000000000',
  },
  createdBy: { // DONE
    id: '94710f06-d86d-4d1e-8ad3-71ec21608e7a',
    profile: {
      id: '680bd471-4b09-4427-be61-31273ac79538',
      firstName: 'PlaybookUX',
      lastName: '',
    },
  },
  testers: [{
    id: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    approved: true,
    testSessions: [{
      id: '74b4ab4e-2267-4a8b-bb71-7914cf488b61',
      videoKey: '74b4ab4e-2267-4a8b-bb71-7914cf488b61.webm',
      videoUrl: 'https://files.playbookux.com/playbook-filler-video.mp4',
      status: 'processed',
      approved: true,
      removed: false,
      testSessionAnswers: [{
        id: '3b63050d-4395-4e93-95e1-7b4d7f00b200',
        question: {
          id: '4a9e7142-86ae-4fb5-94cc-8a39eabe07ab',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 0,
        videoEndTime: 6000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: '88f5e4da-28da-46f0-a086-035df42d8238',
        question: {
          id: '90d3c124-112c-48d4-afbe-538614fc334c',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 6000,
        videoEndTime: 57000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So medium is an article kind of resource. It's a website for different articles. I think I really like reading the reading articles. I think one thing that's a little bit frustrating is that they get the pay wall pretty often. So I don't like that. Of course, I think it's for anyone to share their own article. So it's not just written by one company. They have stuff on all different areas and spaces like startups or design or development. And so yeah, it's really diverse types of articles and they're all written by anyone kind of crowd sourcing of articles.",
            }],
          }],
        },
      }, {
        id: 'c87c5043-221a-4c4e-8eb9-2f15adfeadf1',
        question: {
          id: '57a0b392-26ba-4943-b8ee-d5fd36daf4f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 57000,
        videoEndTime: 92000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Yes, I think their website looks really trustworthy. Maybe it's because I know of the brand and I've heard of the brand but it doesn't look spammy. I don't see ads anywhere. So usually when I think that something's not trustworthy. I see a bunch of scammy types of ads. I don't see that here. So I see a lot of just good quality content not a lot of click bait, so it does feel very trustworthy and reliable.",
            }],
          }],
        },
      }, {
        id: 'ceb5f5a9-79c5-4ee9-b358-d19ff53e2ac6',
        question: {
          id: '50913828-a84b-4f2b-8b09-889ad1bce1fe',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 92000,
        videoEndTime: 196000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I was to find the article about ux what I would do, I would well first of all, I would go to the search bar and I would click so I have to sign in so I'll sign in now. It looks like I have to start my membership. So I'm not going to do that because I don't want to pay when I just want to try and find an article. So that's the one thing I find really frustrating about medium is the pay wall is so quick that they make me pay really quickly. I feel like other publications typically let me read a few more articles for I have to start clicking which is annoying. So I would probably click design here at the top navigation. So OK here. I see an article says popular and design and says UI and UX so I would click on that. So now I'm in this article with UX Planet. So now I see here UX for beginners. The header makes sense and I can find all different types of articles here. So I guess it's just that when I tried to search I had to pay but if I wanted to just click from the home page, I was able to read articles without paying so I thought that's weird because it's not something typically I would see in any sort of other type of article news source that I read. It's usually you can search freely or not prohibited from searching. So I thought that was strange and I didn't really like that part, but I do like how I can read this article without having to pay which is nice.",
            }],
          }],
        },
      }, {
        id: '6b1c4cb9-8ec2-47fb-8a5a-a0d413f07e56',
        question: {
          id: '5ae8e0f3-5fc0-4670-9a4d-923820d96e12',
        },
        questionOptions: [{ id: '85013f99-611d-4c78-8d82-b659cf3ef9c7' }],
        valueInteger: 2,
        videoStartTime: 196000,
        videoEndTime: 217000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "This task was actually a little challenging. I would say probably two. I'm going to rank low because I couldn't search without paying again we're logging in. So I'm that's pretty low for me. I had to click more clicks than I'm used to I think almost three or four clicks. So that was that's going to say that's pretty difficult.",
            }],
          }],
        },
      }, {
        id: '25c55b56-41d3-4671-a9ff-ce467b6139fc',
        question: {
          id: '5f1bfb5d-06b7-4ce7-adf8-9fa0fdb039ce',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 217000,
        videoEndTime: 284000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So I think my impression of this page is it's very clean. It's very simple, which is nice I can see, you know, here's different types of articles again. The one thing is is that it's hard for me to search so I don't like that because I'm I'm type of person who likes to search a lot but you know, I actually really enjoy mediums focus on just the content right? There's not ads on the side. There's not a lot of things here. I get a little bit of social validation when I see the number of clicks claps, so that's nice. So I like that you see the number of claps, but it's not overpowering so I know that other people like this article it's worth reading I see it's about 15 minutes to read which is nice. It doesn't take me too long, which is nice. But again, the navigation is a little confusing like I'm not totally sure where I would find other ux articles that are not in this one kind of ux planet article source of articles.",
            }],
          }],
        },
      }, {
        id: '0e551423-391d-4f52-8abe-49d903d3f08d',
        question: {
          id: '5f52d092-4218-484e-8a92-9df13b18eadb',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 284000,
        videoEndTime: 315000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Okay. So if I was to find an article, that was 6 minutes long or maybe click on to user experience and I would scroll through the articles here. They're nice little snapshots of each of the articles and it says most of these are five minutes. Okay here, so I see designing the perfect search box is 6 minutes long, so I found that pretty quickly.",
            }],
          }],
        },
      }, {
        id: '8ed2b0ec-95cb-4a0b-a57c-b69dcd5b8283',
        question: {
          id: '54056455-19cc-4731-bacc-90a1200f1c72',
        },
        questionOptions: [{ id: '47b24141-5596-431d-a879-89f10f56d576' }],
        valueInteger: 5,
        videoStartTime: 315000,
        videoEndTime: 330000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I'm going to say five that was very easy. It was very clear that how long each of the articles were and then have to filter through a lot of information and I was able to find one faster than I would have expected.",
            }],
          }],
        },
      }, {
        id: '927219fb-261a-40b3-af3d-6b9d74623f88',
        question: {
          id: 'b88ac480-5a50-492c-94bf-3f86c39b5e28',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 330000,
        videoEndTime: 360000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I was to bookmark this page, so on my initial home screen, I don't see a way to bookmark it but then when I scroll down I do see this little save icon. So I would click the save icon and it looks like it's bookmarked. So that seems easy. The only thing is I'm not exactly sure where I would go now to access that but for now, I think that seems pretty simple.",
            }],
          }],
        },
      }, {
        id: '1f15d82e-75c7-4acb-866e-3fd9c760806c',
        question: {
          id: '4306a4d4-4d3b-4080-b328-b12eda8b6141',
        },
        questionOptions: [{ id: '54c66714-60c8-41d1-9a5a-d26080009538' }],
        valueInteger: 5,
        videoStartTime: 360000,
        videoEndTime: 372000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "That was very easy. I had no problem finding that little save icon that that's very universal. So I felt like I had no problem there.",
            }],
          }],
        },
      }, {
        id: 'bc5e3fc5-47b2-4780-adbb-245a6c399590',
        question: {
          id: '3ae0a746-e94f-41bc-ae81-320339440147',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 372000,
        videoEndTime: 372000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: 'a8e17c1a-8d62-40ea-9b07-82c6da363596',
        question: {
          id: '927b1538-e5fc-4aae-8036-01c321e37f22',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 372000,
        videoEndTime: 398000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I was to find the article so I'm going to go to my home kind of account settings here and scroll down. Okay, I see bookmarks is one of the account settings. I'm going to click on that and yep. It's right here. So that was fairly simple. I'd only had to do two clicks to get their actually not even so that was very easy.",
            }],
          }],
        },
      }, {
        id: 'b31434d5-36f1-4d9e-a0be-0a674f8fbe28',
        question: {
          id: 'f208aece-b70e-4ca4-8db8-c141b881db30',
        },
        questionOptions: [{ id: '1ec3243d-7883-4090-a592-d452083fc16a' }],
        valueInteger: 5,
        videoStartTime: 398000,
        videoEndTime: 409000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Very easy, I'm going to give that a 5. I was able to find it super quickly and it was right in the account settings and I like that a lot.",
            }],
          }],
        },
      }, {
        id: 'd86340db-f873-475e-9217-755dfd1f6b05',
        question: {
          id: '11fa09f9-908e-4c70-b666-f45a5aa660f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 409000,
        videoEndTime: 427000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I was to go to this article, I'm going to click back to the article and as I scroll down right next to the bookmark icon. There is a Twitter icon. So I would just click on that and it would give me an option to post on Twitter.",
            }],
          }],
        },
      }, {
        id: 'c3868da8-0a69-41d8-8836-1070c740e91e',
        question: {
          id: '895a2694-6d57-4fcb-80b6-c1b08ce71dbb',
        },
        questionOptions: [{ id: '18c1dfd3-f70b-4b0f-bc41-910dbebad91e' }],
        valueInteger: 5,
        videoStartTime: 427000,
        videoEndTime: 427000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'Was very easy finding Twitter was right next to the bookmark very easy if I wanted to share that.',
            }],
          }],
        },
      }],
    }],
    user: {
      id: 'fc822109-9841-42a6-808f-ceb407964af6',
      profile: {
        id: '88c9cf44-20e4-4a91-8ea6-f30644848845',
        firstName: 'Jill',
        lastName: 'Doe',
        linkedinFields: {
          id: 'PLAYBOOKUX',
          emailAddress: 'hello@playbookux.com',
          educationLevel: "Master's Degree",
          linkedinUrl: 'https://www.playbookux.com',
          currentPosition: {
            title: 'Product Manager',
            description: null,
            seniority: 'Entry-Level',
            company: {
              name: 'Google',
              size: '10,001+',
              industry: 'Internet',
            },
            startDate: {
              year: 2016,
              month: 10,
            },
            endDate: null,
          },
        },
        signUpSurvey: {
          email: 'hello@playbookux.com',
          birthdate: '1988-01-15T00:00:00-04:00',
          gender: 'Female',
          raceEthnicHeritage: 'White / Caucasian',
          annualHouseholdIncome: '$100,001-$150,000',
          otherDevices: [],
          country: 'us',
          state: 'NY',
          jobCategories: [{
            name: '',
          }],
        },
      },
    },
    screenerSession: {
      id: '601d1f7d-8169-4f0e-b39f-aa27bbd18e46',
      screenerSessionAnswers: [{
        id: '349818c4-b3cf-430b-98c8-52dede4e6bdf',
        questionId: '9e42de87-46a1-4852-8143-9cfd331201af',
        questionOptionId: '6abb7b98-96ae-425a-83cf-7b45b95c8c54',
      }],
    },
  }, {
    id: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    approved: true,
    testSessions: [{
      id: '74b4ab4e-2267-4a8b-bb71-7914cf488b61',
      videoKey: '74b4ab4e-2267-4a8b-bb71-7914cf488b61.webm',
      videoUrl: 'https://files.playbookux.com/playbook-filler-video.mp4',
      status: 'processed',
      approved: true,
      removed: false,
      testSessionAnswers: [{
        id: '3b63050d-4395-4e93-95e1-7b4d7f00b200',
        question: {
          id: '4a9e7142-86ae-4fb5-94cc-8a39eabe07ab',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 0,
        videoEndTime: 5000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: '88f5e4da-28da-46f0-a086-035df42d8238',
        question: {
          id: '90d3c124-112c-48d4-afbe-538614fc334c',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 5000,
        videoEndTime: 58000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So the purpose of this page is, it looks like a homepage for and a site that has a bunch of articles with a lot of different categories. It looks like I can read about a lot of wide variety of things. So I'm looking at the design and it looks a little cluttered like I'm not really a fan of this picture over here that's kind of bleeding out into the side. I'm not sure if that's a bug but there are a lot of columns. There are three columns up here and then at that turns to two columns down here. So I'm not a huge fan of this design.",
            }],
          }],
        },
      }, {
        id: 'c87c5043-221a-4c4e-8eb9-2f15adfeadf1',
        question: {
          id: '57a0b392-26ba-4943-b8ee-d5fd36daf4f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 58000,
        videoEndTime: 73000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "This website feels pretty trustworthy. I think if I were to write content, I'd probably post on it. It seems like it is credible though, and I think I think that because of the clean design.",
            }],
          }],
        },
      }, {
        id: 'ceb5f5a9-79c5-4ee9-b358-d19ff53e2ac6',
        question: {
          id: '50913828-a84b-4f2b-8b09-889ad1bce1fe',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 73000,
        videoEndTime: 94000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I want to view articles about UX, I would look for a search bar. So the search bar is kind of hidden, just let me search medium. I'm going to just write UX. I just found it.",
            }],
          }],
        },
      }, {
        id: '6b1c4cb9-8ec2-47fb-8a5a-a0d413f07e56',
        question: {
          id: '5ae8e0f3-5fc0-4670-9a4d-923820d96e12',
        },
        questionOptions: [{ id: 'f18b1cea-37d0-4fc6-8e3c-c3f992833967' }],
        valueInteger: 4,
        videoStartTime: 94000,
        videoEndTime: 106000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "We're gonna give it a four because it was pretty easy except the search bar is kind of hidden, so I didn't know where it was and it's very small, too.",
            }],
          }],
        },
      }, {
        id: '25c55b56-41d3-4671-a9ff-ce467b6139fc',
        question: {
          id: '5f1bfb5d-06b7-4ce7-adf8-9fa0fdb039ce',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 106000,
        videoEndTime: 156000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So I'm on this UX page and it looks like I could search different tags. So if I were to click on design or UX, I would filter down the articles so I don't love what happened there. That's really annoying is that the tags went on the left side as opposed to staying on the right side back? I think it's okay. I think there's just a lot of stuff. They're trying to push a bunch of accounts on me to follow so I can get emails of it, but I'm a little overwhelmed by what's going on and then there's moving parts in this image. So that's kind of frustrating.",
            }],
          }],
        },
      }, {
        id: '0e551423-391d-4f52-8abe-49d903d3f08d',
        question: {
          id: '5f52d092-4218-484e-8a92-9df13b18eadb',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 156000,
        videoEndTime: 188000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I'm looking for an article that's 6 minutes long. Well, that's kind of frustrating because it doesn't actually show that the read time. And I would oh I see it kind of blends in so I'm looking for something I found an article.",
            }],
          }],
        },
      }, {
        id: '8ed2b0ec-95cb-4a0b-a57c-b69dcd5b8283',
        question: {
          id: '54056455-19cc-4731-bacc-90a1200f1c72',
        },
        questionOptions: [{ id: 'ccb9df9c-ab2b-43ae-ae73-ed2b05dac3e6' }],
        valueInteger: 3,
        videoStartTime: 188000,
        videoEndTime: 205000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "It was it wasn't very challenging when I saw where the read time is, but it was hard to view it because it was kind of hidden and it was a light gray color. So I'll give it a 3.",
            }],
          }],
        },
      }, {
        id: '927219fb-261a-40b3-af3d-6b9d74623f88',
        question: {
          id: 'b88ac480-5a50-492c-94bf-3f86c39b5e28',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 205000,
        videoEndTime: 259000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So I want to bookmark but I can't really find a place to bookmark it at first glance, but now I see one. Okay, so I could bookmark it here. I'm clicking on the bookmark because I'm already signed in. It easily bookmarks it but I'm not exactly sure how to retrieve that. It's not clear how I would actually retrieve that so it's kind of confusing and in that regard I'd love to have something on the navigation that shows the bookmark. Maybe an icon.",
            }],
          }],
        },
      }, {
        id: '1f15d82e-75c7-4acb-866e-3fd9c760806c',
        question: {
          id: '4306a4d4-4d3b-4080-b328-b12eda8b6141',
        },
        questionOptions: [{ id: 'e6cdeef8-46df-4879-bd02-615674c6bea1' }],
        valueInteger: 4,
        videoStartTime: 259000,
        videoEndTime: 277000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'I give it a four because the once I found it it was kind of obvious where it was but everything on that side panel the social icons all blend together.',
            }],
          }],
        },
      }, {
        id: 'bc5e3fc5-47b2-4780-adbb-245a6c399590',
        question: {
          id: '3ae0a746-e94f-41bc-ae81-320339440147',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 277000,
        videoEndTime: 277000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: 'a8e17c1a-8d62-40ea-9b07-82c6da363596',
        question: {
          id: '927b1538-e5fc-4aae-8036-01c321e37f22',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 277000,
        videoEndTime: 304000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'So if I were to find the article, I would go to K which is my initial know and I see bookmarks here. Okay, so the screen looks very bare, but I found it when I could see I see that I can remove it and I can click on it if I choose to read it.',
            }],
          }],
        },
      }, {
        id: 'b31434d5-36f1-4d9e-a0be-0a674f8fbe28',
        question: {
          id: 'f208aece-b70e-4ca4-8db8-c141b881db30',
        },
        questionOptions: [{ id: 'da0bf0d0-a028-424f-aa67-02ff37e9b63' }],
        valueInteger: 4,
        videoStartTime: 304000,
        videoEndTime: 329000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I'd say a four. I didn't really love. The design of the screen and when I looked at the settings drop down, it was really overwhelming because there are a ton of a ton of different settings. So it was kind of difficult to find in that respect but once I found it it was pretty easy.",
            }],
          }],
        },
      }, {
        id: 'd86340db-f873-475e-9217-755dfd1f6b05',
        question: {
          id: '11fa09f9-908e-4c70-b666-f45a5aa660f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 329000,
        videoEndTime: 343000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'So if I were to share this article, I would probably click on the article. And then on the sidebar, I would share it so I click Twitter.',
            }],
          }],
        },
      }, {
        id: 'c3868da8-0a69-41d8-8836-1070c740e91e',
        question: {
          id: '895a2694-6d57-4fcb-80b6-c1b08ce71dbb',
        },
        questionOptions: [{ id: '18c1dfd3-f70b-4b0f-bc41-910dbebad91e' }],
        valueInteger: 5,
        videoStartTime: 343000,
        videoEndTime: 343000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'That was very easy. It was really easy to see what to do. The social icons are. Stay with me as I scroll so I could see them wherever I am.',
            }],
          }],
        },
      }],
    }],
    user: {
      id: 'f2cf11f7-92bc-43ad-89d6-8c7b5344c2a3',
      profile: {
        id: '07a6e9b0-81c6-4120-9683-c9e3460921f2',
        firstName: 'Ashley',
        lastName: 'Doe',
        linkedinFields: {
          id: 'PLAYBOOKUX',
          emailAddress: 'hello@playbookux.com',
          educationLevel: "Bachelor's Degree",
          linkedinUrl: 'https://www.playbookux.com',
          currentPosition: {
            title: 'UI Design Lead',
            description: null,
            seniority: 'Manager',
            company: {
              name: 'Salesforce',
              size: '10,001+',
              industry: 'Internet',
            },
            startDate: {
              year: 2018,
              month: 1,
            },
            endDate: null,
          },
        },
        signUpSurvey: {
          email: 'hello@playbookux.com',
          birthdate: '1992-01-15T00:00:00-04:00',
          gender: 'Female',
          raceEthnicHeritage: 'Black or African American',
          annualHouseholdIncome: '$200,001-$250,000',
          otherDevices: [],
          country: 'us',
          state: 'CA',
          jobCategories: [{
            name: '',
          }],
        },
      },
    },
    screenerSession: {
      id: '601d1f7d-8169-4f0e-b39f-aa27bbd18e46',
      screenerSessionAnswers: [{
        id: '349818c4-b3cf-430b-98c8-52dede4e6bdf',
        questionId: '9e42de87-46a1-4852-8143-9cfd331201af',
        questionOptionId: '6abb7b98-96ae-425a-83cf-7b45b95c8c54',
      }],
    },
  }, {
    id: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    approved: true,
    testSessions: [{
      id: '9af4549d-388c-4229-8525-318c295a432a',
      videoKey: '9af4549d-388c-4229-8525-318c295a432a.webm',
      videoUrl: 'https://files.playbookux.com/playbook-filler-video.mp4',
      status: 'processed',
      approved: true,
      removed: false,
      testSessionAnswers: [{
        id: '3b63050d-4395-4e93-95e1-7b4d7f00b200',
        question: {
          id: '4a9e7142-86ae-4fb5-94cc-8a39eabe07ab',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 0,
        videoEndTime: 8000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: '88f5e4da-28da-46f0-a086-035df42d8238',
        question: {
          id: '90d3c124-112c-48d4-afbe-538614fc334c',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 8000,
        videoEndTime: 56000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Okay, so this website looks like it posts a bunch of stories and articles. I'm looks like I can sign up for it. I feel pretty overwhelmed because there's a lot going on at this top. I'm not really sure there seems like there's three columns of stories that are different heights and widths I guess they're the featured stories, but it's a little overwhelming and my eyes really aren't drawn to anything but it looks like I can read a bunch of articles and view stories.",
            }],
          }],
        },
      }, {
        id: 'c87c5043-221a-4c4e-8eb9-2f15adfeadf1',
        question: {
          id: '57a0b392-26ba-4943-b8ee-d5fd36daf4f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 56000,
        videoEndTime: 89000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "The website looks okay. It feels decently trustworthy. I mean I wouldn't not trust it but it also doesn't look that nice especially with the white background and just black font. It's it doesn't seem like a lot of But overall I think I would trust it. I probably wouldn't put it credit card information in but I trust it.",
            }],
          }],
        },
      }, {
        id: 'ceb5f5a9-79c5-4ee9-b358-d19ff53e2ac6',
        question: {
          id: '50913828-a84b-4f2b-8b09-889ad1bce1fe',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 89000,
        videoEndTime: 137000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I want to view articles about UX I look at the top portion here, so I can't find anything that says UX or design. So oh wow. Okay, so I accidentally put become a member. I thought that this become member was sort of in the search bar. So let me just pick that small search I would search UX and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here. But okay. So now I have this giant search don't think those very intuitive but that makes sense.",
            }],
          }],
        },
      }, {
        id: '6b1c4cb9-8ec2-47fb-8a5a-a0d413f07e56',
        question: {
          id: '5ae8e0f3-5fc0-4670-9a4d-923820d96e12',
        },
        questionOptions: [{ id: '85013f99-611d-4c78-8d82-b659cf3ef9c7' }],
        valueInteger: 2,
        videoStartTime: 137000,
        videoEndTime: 157000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "It wasn't very intuitive. I felt like I was a little confused. I accidentally clicked on the wrong place and I wasn't sure that they're interesting people on Publications. I figured it would just show me stories immediately. So yeah, I would have wanted to just land on a page that showed me my stories.",
            }],
          }],
        },
      }, {
        id: '25c55b56-41d3-4671-a9ff-ce467b6139fc',
        question: {
          id: '5f1bfb5d-06b7-4ce7-adf8-9fa0fdb039ce',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 157000,
        videoEndTime: 204000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Okay. So on this page my impression is that it's pretty standard. I mean there's a lot. Like this catches my eye the fact that there's motion in one of these titles not sure that I like that very much but I know that I can read articles about UX I could upvote them essentially by clicking on the hands. I can see how many people commented on it and how long it takes to read and who it was from. I don't know the difference between like UX and motion for UX Planet first prototype. I don't know if those are different companies that are just publishing information or if they're just different like segments of the article, so I'm a little confused on that.",
            }],
          }],
        },
      }, {
        id: '0e551423-391d-4f52-8abe-49d903d3f08d',
        question: {
          id: '5f52d092-4218-484e-8a92-9df13b18eadb',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 204000,
        videoEndTime: 245000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So I'm about to run off to a meeting. I would look for something that is 6 minutes and okay, so I see one that's 5 minutes. I see the 5 minutes up by the top of it. There's a huge disconnect between the picture with the person's name and the date and also the title, so I was a little confused on that. but So I see this one that is 5 minutes. So I'm going to click on that.",
            }],
          }],
        },
      }, {
        id: '8ed2b0ec-95cb-4a0b-a57c-b69dcd5b8283',
        question: {
          id: '54056455-19cc-4731-bacc-90a1200f1c72',
        },
        questionOptions: [{ id: '1aa109e9-3b50-417b-9f79-f962673b5e76' }],
        valueInteger: 4,
        videoStartTime: 245000,
        videoEndTime: 272000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I was pretty easy. I saw the number of minutes at the top but I wish that to be image kind of breaks up the title and the author slash number of minutes. So I kind of wish that they were together. So if the image were on top and the person's name and the minutes of reading, we're on the bottom with the title, that would have been nicer.",
            }],
          }],
        },
      }, {
        id: '927219fb-261a-40b3-af3d-6b9d74623f88',
        question: {
          id: 'b88ac480-5a50-492c-94bf-3f86c39b5e28',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 272000,
        videoEndTime: 301000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess. Okay.",
            }],
          }],
        },
      }, {
        id: '1f15d82e-75c7-4acb-866e-3fd9c760806c',
        question: {
          id: '4306a4d4-4d3b-4080-b328-b12eda8b6141',
        },
        questionOptions: [{ id: '2952f742-616c-43b4-9e55-b0e3acc337eb' }],
        valueInteger: 3,
        videoStartTime: 301000,
        videoEndTime: 331000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I thought I didn't really see it. At first I would have expected it to be on the top of the page. Also. I think I'd need to get used to that symbol that they're using for bookmark. It would be better. If it said it had the symbol plus it said bookmark underneath like adding words underneath the icon because I was not familiar with that icon.",
            }],
          }],
        },
      }, {
        id: 'bc5e3fc5-47b2-4780-adbb-245a6c399590',
        question: {
          id: '3ae0a746-e94f-41bc-ae81-320339440147',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 331000,
        videoEndTime: 331000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: 'a8e17c1a-8d62-40ea-9b07-82c6da363596',
        question: {
          id: '927b1538-e5fc-4aae-8036-01c321e37f22',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 331000,
        videoEndTime: 361000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So I'm back from my meeting and I want to find the article that I book marked. So I'm going to go click on this icon. This is my account settings. I would assume so I could post a story not sure if the medium partner program is but it says bookmarks and now I see all the different things that I've bookmarked.",
            }],
          }],
        },
      }, {
        id: 'b31434d5-36f1-4d9e-a0be-0a674f8fbe28',
        question: {
          id: 'f208aece-b70e-4ca4-8db8-c141b881db30',
        },
        questionOptions: [{ id: 'da0bf0d0-a028-424f-aa67-02ff37e9b63f' }],
        valueInteger: 4,
        videoStartTime: 361000,
        videoEndTime: 371000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I thought it was fairly simple. I mean, I knew it was an account settings, but I didn't realize how far an account settings it was.",
            }],
          }],
        },
      }, {
        id: 'd86340db-f873-475e-9217-755dfd1f6b05',
        question: {
          id: '11fa09f9-908e-4c70-b666-f45a5aa660f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 371000,
        videoEndTime: 390000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I want to share this article on Twitter, I would look so it's as soon as I explore all down. I see the social icons. So I put Twitter and I shared on Twitter then.",
            }],
          }],
        },
      }, {
        id: 'c3868da8-0a69-41d8-8836-1070c740e91e',
        question: {
          id: '895a2694-6d57-4fcb-80b6-c1b08ce71dbb',
        },
        questionOptions: [{ id: 'da0bf0d0-a028-424f-aa67-02ff37e9b63f' }],
        valueInteger: 4,
        videoStartTime: 390000,
        videoEndTime: 390000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "It was fairly simple. I think I was confused because as soon as I started scrolling I saw the social icons, but I didn't see them initially.",
            }],
          }],
        },
      }],
    }],
    user: {
      id: '3a86dcf8-5985-4a5e-bab9-909e15116c57',
      profile: {
        id: '0cde3c49-9f45-4d35-a79e-a785604b2af9',
        firstName: 'John',
        lastName: 'Doe',
        linkedinFields: {
          id: 'PLAYBOOKUX',
          emailAddress: 'hello@playbookux.com',
          educationLevel: "Bachelor's Degree",
          linkedinUrl: 'https://www.playbookux.com',
          currentPosition: {
            title: 'Sr. Product Manager',
            description: null,
            seniority: 'Senior',
            company: {
              name: 'Udemy',
              size: '201-500',
              industry: 'E-Learning',
            },
            startDate: {
              year: 2019,
              month: 5,
            },
            endDate: null,
          },
        },
        signUpSurvey: {
          email: 'hello@playbookux.com',
          birthdate: '1980-01-15T00:00:00-04:00',
          gender: 'Male',
          raceEthnicHeritage: 'Black or African American',
          annualHouseholdIncome: '$100,001-$150,000',
          otherDevices: [],
          country: 'us',
          state: 'NJ',
          jobCategories: [{
            name: '',
          }],
        },
      },
    },
    screenerSession: {
      id: '601d1f7d-8169-4f0e-b39f-aa27bbd18e46',
      screenerSessionAnswers: [{
        id: '349818c4-b3cf-430b-98c8-52dede4e6bdf',
        questionId: '9e42de87-46a1-4852-8143-9cfd331201af',
        questionOptionId: '0e9d784b-7e1b-46c9-9221-c988c4c9e332',
      }],
    },
  }, {
    id: '09a7adec-b51a-4305-bbef-973092fd7868',
    approved: true,
    testSessions: [{
      id: '7c13c3e9-e290-4f1a-a65c-bb96ce1cfeba',
      videoKey: '7c13c3e9-e290-4f1a-a65c-bb96ce1cfeba.webm',
      videoUrl: 'https://files.playbookux.com/playbook-filler-video.mp4',
      status: 'processed',
      approved: true,
      removed: false,
      testSessionAnswers: [{
        id: '3b63050d-4395-4e93-95e1-7b4d7f00b200',
        question: {
          id: '4a9e7142-86ae-4fb5-94cc-8a39eabe07ab',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 0,
        videoEndTime: 4000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: '88f5e4da-28da-46f0-a086-035df42d8238',
        question: {
          id: '90d3c124-112c-48d4-afbe-538614fc334c',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 4000,
        videoEndTime: 23000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "This looks like a page where I could read articles. It looks like there are a ton of different categories that are all these different headers. It looks like they're featured articles that are being shown up top. It looks like I could sign up for these articles.",
            }],
          }],
        },
      }, {
        id: 'c87c5043-221a-4c4e-8eb9-2f15adfeadf1',
        question: {
          id: '57a0b392-26ba-4943-b8ee-d5fd36daf4f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 23000,
        videoEndTime: 41000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "This website seems trustworthy. It seems a little bland with a white background and black text but it does seem trustworthy. I've heard of this brand before and it looks like a ton of people right for them. ",
            }],
          }],
        },
      }, {
        id: 'ceb5f5a9-79c5-4ee9-b358-d19ff53e2ac6',
        question: {
          id: '50913828-a84b-4f2b-8b09-889ad1bce1fe',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 41000,
        videoEndTime: 83000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "If I want to view articles about UX I think I would click, none of these categories really show you UX so I'm going to click more. I'm going to scroll through so I don't think it's arts and entertainment. So it's not an industry, which is a little weird. Well, maybe it's design so I will click on design and I'm looking at related topics and says UX here. Now I see a landing page that's all about UX. ",
            }],
          }],
        },
      }, {
        id: '6b1c4cb9-8ec2-47fb-8a5a-a0d413f07e56',
        question: {
          id: '5ae8e0f3-5fc0-4670-9a4d-923820d96e12',
        },
        questionOptions: [{ id: '95bc7296-84c6-4663-9ba0-c5b157be3f0c' }],
        valueInteger: 3,
        videoStartTime: 83000,
        videoEndTime: 96000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I'd say this was a moderate task. It seems like it could have been shorter. There were a ton of clicks that I had to take to get to UX.",
            }],
          }],
        },
      }, {
        id: '25c55b56-41d3-4671-a9ff-ce467b6139fc',
        question: {
          id: '5f1bfb5d-06b7-4ce7-adf8-9fa0fdb039ce',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 96000,
        videoEndTime: 141000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "My impression is that on this page there are a ton of articles here. It looks like I could follow this entire category. It's weird that it says all about that user. It doesn't really make sense because UX is about the user. It's a industry so I can see the latest articles and then there's some featured writers. I think I could read articles about UX and some of these images look a little weird.",
            }],
          }],
        },
      }, {
        id: '0e551423-391d-4f52-8abe-49d903d3f08d',
        question: {
          id: '5f52d092-4218-484e-8a92-9df13b18eadb',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 141000,
        videoEndTime: 177000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So if I'm looking for something that's around 6 minutes. It's really easy to see that here. I could see the title a little description the person and the date and then number of minutes to read. I think it's a little weird. I'm not really sure what UX collected means or the startup. I don't know if these are companies or just segments of different verticals within medium, but here's a 6 minute article. So I'm going to click on that.",
            }],
          }],
        },
      }, {
        id: '8ed2b0ec-95cb-4a0b-a57c-b69dcd5b8283',
        question: {
          id: '54056455-19cc-4731-bacc-90a1200f1c72',
        },
        questionOptions: [{ id: '47b24141-5596-431d-a879-89f10f56d576' }],
        valueInteger: 5,
        videoStartTime: 177000,
        videoEndTime: 184000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'I thought that was very easy. It was really easy to see how long the articles are.',
            }],
          }],
        },
      }, {
        id: '927219fb-261a-40b3-af3d-6b9d74623f88',
        question: {
          id: 'b88ac480-5a50-492c-94bf-3f86c39b5e28',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 184000,
        videoEndTime: 220000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I'm so I want to bookmark. This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark. Okay, and now I'm going to sign in.",
            }],
          }],
        },
      }, {
        id: '1f15d82e-75c7-4acb-866e-3fd9c760806c',
        question: {
          id: '4306a4d4-4d3b-4080-b328-b12eda8b6141',
        },
        questionOptions: [{ id: '54c66714-60c8-41d1-9a5a-d26080009538' }],
        valueInteger: 5,
        videoStartTime: 220000,
        videoEndTime: 229000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'I thought it was very easy. The Bookmark icon is pretty apparent on the side of the screen.',
            }],
          }],
        },
      }, {
        id: 'bc5e3fc5-47b2-4780-adbb-245a6c399590',
        question: {
          id: '3ae0a746-e94f-41bc-ae81-320339440147',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 229000,
        videoEndTime: 229000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: 'a8e17c1a-8d62-40ea-9b07-82c6da363596',
        question: {
          id: '927b1538-e5fc-4aae-8036-01c321e37f22',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 229000,
        videoEndTime: 257000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So to look for that bookmark article, I'm going to scroll to the footer and I don't think I can get there because the articles are just in a feed. So I go up to the top. I'm going to click on that icon with my initial in it and then look for bookmarks and I found that exact article.",
            }],
          }],
        },
      }, {
        id: 'b31434d5-36f1-4d9e-a0be-0a674f8fbe28',
        question: {
          id: 'f208aece-b70e-4ca4-8db8-c141b881db30',
        },
        questionOptions: [{ id: '1ec3243d-7883-4090-a592-d452083fc16a' }],
        valueInteger: 5,
        videoStartTime: 257000,
        videoEndTime: 264000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'I thought that was pretty easy. I was able to find it fairly quickly.',
            }],
          }],
        },
      }, {
        id: 'd86340db-f873-475e-9217-755dfd1f6b05',
        question: {
          id: '11fa09f9-908e-4c70-b666-f45a5aa660f',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 264000,
        videoEndTime: 288000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So now I'm looking for a Twitter icon and I see it on the side of the panel. I kind of wish it was it stood out a little more because the icons are all black. So it maybe it'd be nice to just have an outline. That's the Twitter color and an outline of Facebook.",
            }],
          }],
        },
      }, {
        id: 'c3868da8-0a69-41d8-8836-1070c740e91e',
        question: {
          id: '895a2694-6d57-4fcb-80b6-c1b08ce71dbb',
        },
        questionOptions: [{ id: '18c1dfd3-f70b-4b0f-bc41-910dbebad91e' }],
        valueInteger: 5,
        videoStartTime: 288000,
        videoEndTime: 288000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I thought it's pretty easy. It's very apparent that the Twitter icon is where it is. It's stays on the left hand side as I scroll.",
            }],
          }],
        },
      }],
    }],
    user: {
      id: '0cfb681e-d784-4fed-97a9-d5dd7ce17296',
      profile: {
        id: '0ad29ea5-3bb3-4977-a576-09564b8a28dd',
        firstName: 'Mason',
        lastName: 'Doe',
        linkedinFields: {
          id: 'PLAYBOOKUX',
          emailAddress: 'hello@playbookux.com',
          educationLevel: "Master's Degree",
          linkedinUrl: 'https://www.playbookux.com',
          currentPosition: {
            title: 'Director of UX Research',
            description: null,
            seniority: 'Director',
            company: {
              name: 'Box',
              size: '1,001-5,000',
              industry: 'Internet',
            },
            startDate: {
              year: 2017,
              month: 8,
            },
            endDate: null,
          },
        },
        signUpSurvey: {
          email: 'hello@playbookux.com',
          birthdate: '1978-01-15T00:00:00-04:00',
          gender: 'Male',
          raceEthnicHeritage: 'Asian or Pacific Islander',
          annualHouseholdIncome: '$100,001-$150,000',
          otherDevices: [],
          country: 'us',
          state: 'CA',
          jobCategories: [{
            name: '',
          }],
        },
      },
    },
    screenerSession: {
      id: '601d1f7d-8169-4f0e-b39f-aa27bbd18e46',
      screenerSessionAnswers: [{
        id: '349818c4-b3cf-430b-98c8-52dede4e6bdf',
        questionId: '9e42de87-46a1-4852-8143-9cfd331201af',
        questionOptionId: '6abb7b98-96ae-425a-83cf-7b45b95c8c54',
      }],
    },
  }, {
    id: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    approved: true,
    testSessions: [{
      id: '4d0b680e-6260-4f42-952c-3382405bc434',
      videoKey: '4d0b680e-6260-4f42-952c-3382405bc434.webm',
      videoUrl: 'https://files.playbookux.com/playbook-filler-video.mp4',
      status: 'processed',
      approved: true,
      removed: false,
      testSessionAnswers: [{
        id: '3b63050d-4395-4e93-95e1-7b4d7f00b200',
        question: {
          id: '4a9e7142-86ae-4fb5-94cc-8a39eabe07ab',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 0,
        videoEndTime: 5000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: '88f5e4da-28da-46f0-a086-035df42d8238',
        question: {
          id: '90d3c124-112c-48d4-afbe-538614fc334c',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 5000,
        videoEndTime: 70000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So I think the design looks clean. I really like how everything is really simple and the only colors that they have are the colors of the articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest. It's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
            }],
          }],
        },
      }, {
        id: 'c87c5043-221a-4c4e-8eb9-2f15adfeadf1',
        question: {
          id: '57a0b392-26ba-4943-b8ee-d5fd36daf4f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 70000,
        videoEndTime: 108000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "This is website looks very trustworthy. I feel like it looks very professional and I would like to read a lot of articles on here. I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because it doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
            }],
          }],
        },
      }, {
        id: 'ceb5f5a9-79c5-4ee9-b358-d19ff53e2ac6',
        question: {
          id: '50913828-a84b-4f2b-8b09-889ad1bce1fe',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 108000,
        videoEndTime: 190000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So in order to find an article on UX I would sign in first here so then I would go to the search bar and just write UX. Right and here right away. I see multiple articles on UX and I can keep scrolling down and looks like they have a lot of articles on UX which is really nice. So I like that I see a lot of content on UX and I also see on the right hand side tags. And each of these I could the first thing is you asked which is exactly what I searched for. But I like how it also has the other related terms to let other related keywords that may be associated with UX. So design user experience UI so I like that had suggest options for me. That's really nice and also suggest people that I could read so these are kind of trusted sources I would say I would think that they are people who write about UX. So I like that a lot as well as publication. So yeah like this is very easy.",
            }],
          }],
        },
      }, {
        id: '6b1c4cb9-8ec2-47fb-8a5a-a0d413f07e56',
        question: {
          id: '5ae8e0f3-5fc0-4670-9a4d-923820d96e12',
        },
        questionOptions: [{ id: '2bd56600-3356-46f2-abac-43d08ed0f51d' }],
        valueInteger: 5,
        videoStartTime: 190000,
        videoEndTime: 210000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "That's was very easy. I would give it a 5. I really just typed it in the search bar. And I saw many different options right away it suggestion option suggested people. I really liked how simple was I didn't it wasn't too hard for me to find and I thought it was really nice.",
            }],
          }],
        },
      }, {
        id: '25c55b56-41d3-4671-a9ff-ce467b6139fc',
        question: {
          id: '5f1bfb5d-06b7-4ce7-adf8-9fa0fdb039ce',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 210000,
        videoEndTime: 261000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "My first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice. So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the clapping hands which means that a lot of people like this article. So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like how its structured for that purpose.",
            }],
          }],
        },
      }, {
        id: '0e551423-391d-4f52-8abe-49d903d3f08d',
        question: {
          id: '5f52d092-4218-484e-8a92-9df13b18eadb',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 261000,
        videoEndTime: 303000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "So those find an article that's 6 minutes long. Okay, so at the top next to the person's name, it says the amount of time that the article is so I'm not seeing specifically 6 minutes, but I do see other length articles so I know that it I know where to find. I just am not finding. Okay. Here we go. So I found this article redesigning the New York Times app case study. So I would click on that header here and that would open.",
            }],
          }],
        },
      }, {
        id: '8ed2b0ec-95cb-4a0b-a57c-b69dcd5b8283',
        question: {
          id: '54056455-19cc-4731-bacc-90a1200f1c72',
        },
        questionOptions: [{ id: '47b24141-5596-431d-a879-89f10f56d576' }],
        valueInteger: 5,
        videoStartTime: 303000,
        videoEndTime: 328000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "I would say this task was very easy. I was able to see how how long each article was and I didn't have a problem finding one. That was 6 minutes long is very simple. I was able to do it very quickly and because there wasn't a lot of other content on the page. It was just focused on the really information. I wanted to know I was able to quickly find it.",
            }],
          }],
        },
      }, {
        id: '927219fb-261a-40b3-af3d-6b9d74623f88',
        question: {
          id: 'b88ac480-5a50-492c-94bf-3f86c39b5e28',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 328000,
        videoEndTime: 355000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "If I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the clapping hands. So that was pretty easy for me to do.",
            }],
          }],
        },
      }, {
        id: '1f15d82e-75c7-4acb-866e-3fd9c760806c',
        question: {
          id: '4306a4d4-4d3b-4080-b328-b12eda8b6141',
        },
        questionOptions: [{ id: '54c66714-60c8-41d1-9a5a-d26080009538' }],
        valueInteger: 5,
        videoStartTime: 355000,
        videoEndTime: 367000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'This task is very easy. I found the bookmark right away. No issues there it just appeared when I started scrolling and that was it.',
            }],
          }],
        },
      }, {
        id: 'bc5e3fc5-47b2-4780-adbb-245a6c399590',
        question: {
          id: '3ae0a746-e94f-41bc-ae81-320339440147',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 367000,
        videoEndTime: 370000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: 'a8e17c1a-8d62-40ea-9b07-82c6da363596',
        question: {
          id: '927b1538-e5fc-4aae-8036-01c321e37f22',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 370000,
        videoEndTime: 417000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Let me check out the initial icon. I think i should find it there. It's kind of confusing but I see the Bookmark tab, and I can find all of my bookmarked articles.",
            }],
          }],
        },
      }, {
        id: 'b31434d5-36f1-4d9e-a0be-0a674f8fbe28',
        question: {
          id: 'f208aece-b70e-4ca4-8db8-c141b881db30',
        },
        questionOptions: [{ id: '1ec3243d-7883-4090-a592-d452083fc16a' }],
        valueInteger: 5,
        videoStartTime: 417000,
        videoEndTime: 431000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: null,
            }],
          }],
        },
      }, {
        id: 'd86340db-f873-475e-9217-755dfd1f6b05',
        question: {
          id: '11fa09f9-908e-4c70-b666-f45a5aa660f0',
        },
        questionOptions: [],
        valueInteger: null,
        videoStartTime: 431000,
        videoEndTime: 459000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: "Go back to this article. So right underneath the bookmark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple. So I would just click login and tweet.",
            }],
          }],
        },
      }, {
        id: 'c3868da8-0a69-41d8-8836-1070c740e91e',
        question: {
          id: '895a2694-6d57-4fcb-80b6-c1b08ce71dbb',
        },
        questionOptions: [{ id: '18c1dfd3-f70b-4b0f-bc41-910dbebad91e' }],
        valueInteger: 5,
        videoStartTime: 459000,
        videoEndTime: 468000,
        transcript: {
          results: [{
            alternatives: [{
              confidence: 1,
              transcript: 'This is very easy. They make social sharing media makes social sharing really simple and easy, so it was very easy.',
            }],
          }],
        },
      }],
    }],
    user: {
      id: 'd8befd4d-d8df-4198-b2d6-166d814ab682',
      profile: {
        id: '176d8335-3703-4edf-a985-10395d5da157',
        firstName: 'Lance',
        lastName: 'Doe',
        linkedinFields: {
          id: 'PLAYBOOKUX',
          emailAddress: 'hello@playbookux.com',
          educationLevel: "Bachelor's Degree",
          linkedinUrl: 'https://www.playbookux.com',
          currentPosition: {
            title: 'UX Manager',
            description: null,
            seniority: 'Manager',
            company: {
              name: 'Mailchimp',
              size: '501-1,000',
              industry: 'Information Services',
            },
            startDate: {
              year: 2016,
              month: 7,
            },
            endDate: null,
          },
        },
        signUpSurvey: {
          email: 'hello@playbookux.com',
          birthdate: '1990-01-15T00:00:00-04:00',
          gender: 'Male',
          raceEthnicHeritage: 'White / Caucasian',
          annualHouseholdIncome: '$200,001-$250,000',
          otherDevices: [],
          country: 'us',
          state: 'NV',
          jobCategories: [{
            name: '',
          }],
        },
      },
    },
    screenerSession: {
      id: '601d1f7d-8169-4f0e-b39f-aa27bbd18e46',
      screenerSessionAnswers: [{
        id: '349818c4-b3cf-430b-98c8-52dede4e6bdf',
        questionId: '9e42de87-46a1-4852-8143-9cfd331201af',
        questionOptionId: '0e9d784b-7e1b-46c9-9221-c988c4c9e332',
      }],
    },
  }],
  members: [{ // DONE
    id: '9058456b-f8df-40f4-97b4-9679b711169f',
    profile: {
      id: '680bd471-4b09-4427-be61-31273ac79538',
      firstName: 'PlaybookUX',
      lastName: '',
    },
  }, {
    id: 'd6699401-c540-4e10-8030-820e7fac53b6',
    profile: {
      id: 'c9299f68-4e27-4d1d-b76e-d8f40eec556d',
      firstName: 'William',
      lastName: 'Jane',
    },
  }, {
    id: '7e2c78a3-56bb-47ec-afd6-d36d0ec5cdc4',
    profile: {
      id: 'b7ad2850-4277-4604-bcec-6b2e0eb2c9fd',
      firstName: 'Marie',
      lastName: 'Austin',
    },
  }],
  surveys: [{ // DONE
    id: '765656a3-b3d4-4202-8c59-f190539deb4e',
    surveyType: 'session',
    questions: [{
      id: '4a9e7142-86ae-4fb5-94cc-8a39eabe07ab',
      label: 'https://www.medium.com/',
      questionType: 'url',
      questionOrder: 1,
      groupId: '42026b53-b202-22fc-0a49-ff58d508601c',
      questionOptions: [],
    }, {
      id: '90d3c124-112c-48d4-afbe-538614fc334c',
      label: 'Scroll up and down the page and let us know what you think of the overall design. What do you think the purpose of this page is?',
      questionType: 'task',
      questionOrder: 2,
      groupId: '42026b53-b202-22fc-0a49-ff58d508601c',
      questionOptions: [],
    }, {
      id: '57a0b392-26ba-4943-b8ee-d5fd36daf4f0',
      label: 'Does this website feel trustworthy?',
      questionType: 'task',
      questionOrder: 3,
      groupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
      questionOptions: [],
    }, {
      id: '50913828-a84b-4f2b-8b09-889ad1bce1fe',
      label: 'You want to view articles about UX. How would you go about finding it? Find it now.\n',
      questionType: 'task',
      questionOrder: 4,
      groupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
      questionOptions: [],
    }, {
      id: '5ae8e0f3-5fc0-4670-9a4d-923820d96e12',
      label: 'Overall, this task was:',
      questionType: 'range',
      questionOrder: 5,
      groupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
      questionOptions: [{
        id: 'fb2f60d2-e989-483e-b943-2e19206a4a18',
        label: '1',
        disqualify: null,
      }, {
        id: '85013f99-611d-4c78-8d82-b659cf3ef9c7',
        label: '2',
        disqualify: null,
      }, {
        id: '95bc7296-84c6-4663-9ba0-c5b157be3f0c',
        label: '3',
        disqualify: null,
      }, {
        id: 'f18b1cea-37d0-4fc6-8e3c-c3f992833967',
        label: '4',
        disqualify: null,
      }, {
        id: '2bd56600-3356-46f2-abac-43d08ed0f51d',
        label: '5',
        disqualify: null,
      }],
    }, {
      id: '5f1bfb5d-06b7-4ce7-adf8-9fa0fdb039ce',
      label: "Now that you're on the UX page, what are your impressions on this page? What can you do on this page?",
      questionType: 'task',
      questionOrder: 6,
      groupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
      questionOptions: [],
    }, {
      id: '5f52d092-4218-484e-8a92-9df13b18eadb',
      label: "You're about to run off to a meeting, but you have 7 minutes to spare beforehand. Find an article that's around 6 minutes long.",
      questionType: 'task',
      questionOrder: 7,
      groupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
      questionOptions: [],
    }, {
      id: '54056455-19cc-4731-bacc-90a1200f1c72',
      label: 'Overall, this task was:',
      questionType: 'range',
      questionOrder: 8,
      groupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
      questionOptions: [{
        id: 'c2697ded-6964-4b26-b508-ef90bc088208',
        label: '1',
        disqualify: null,
      }, {
        id: '956e5ad7-0123-479c-ab61-b5892bba386b',
        label: '2',
        disqualify: null,
      }, {
        id: 'ccb9df9c-ab2b-43ae-ae73-ed2b05dac3e6',
        label: '3',
        disqualify: null,
      }, {
        id: '1aa109e9-3b50-417b-9f79-f962673b5e76',
        label: '4',
        disqualify: null,
      }, {
        id: '47b24141-5596-431d-a879-89f10f56d576',
        label: '5',
        disqualify: null,
      }],
    }, {
      id: 'b88ac480-5a50-492c-94bf-3f86c39b5e28',
      label: "Your boss comes over to your desk, so you can't read your article. Bookmark it so you can read it after your meeting. Take the action of bookmarking the article.\n",
      questionType: 'task',
      questionOrder: 9,
      groupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
      questionOptions: [],
    }, {
      id: '4306a4d4-4d3b-4080-b328-b12eda8b6141',
      label: 'Overall, this task was:',
      questionType: 'range',
      questionOrder: 10,
      groupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
      questionOptions: [{
        id: 'dd09e537-792f-46d2-aa85-4a439ee7e839',
        label: '1',
        disqualify: null,
      }, {
        id: '07fa9772-3707-4e4a-85eb-b2cab4c9873b',
        label: '2',
        disqualify: null,
      }, {
        id: '2952f742-616c-43b4-9e55-b0e3acc337eb',
        label: '3',
        disqualify: null,
      }, {
        id: 'e6cdeef8-46df-4879-bd02-615674c6bea1',
        label: '4',
        disqualify: null,
      }, {
        id: '54c66714-60c8-41d1-9a5a-d26080009538',
        label: '5',
        disqualify: null,
      }],
    }, {
      id: '3ae0a746-e94f-41bc-ae81-320339440147',
      label: 'https://www.medium.com/',
      questionType: 'url',
      questionOrder: 11,
      groupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
      questionOptions: [],
    }, {
      id: '927b1538-e5fc-4aae-8036-01c321e37f22',
      label: "Now that you're back from your meeting, find that article.",
      questionType: 'task',
      questionOrder: 12,
      groupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
      questionOptions: [],
    }, {
      id: 'f208aece-b70e-4ca4-8db8-c141b881db30',
      label: 'Overall, this task was:',
      questionType: 'range',
      questionOrder: 13,
      groupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
      questionOptions: [{
        id: 'ded5d349-c6b9-4d46-afac-9c5e072ceb77',
        label: '1',
        disqualify: null,
      }, {
        id: '8cf51963-1ec9-46d4-bcef-9116b620103f',
        label: '2',
        disqualify: null,
      }, {
        id: 'c18beaf8-04a7-4347-b4fe-6c079c724f6c',
        label: '3',
        disqualify: null,
      }, {
        id: 'da0bf0d0-a028-424f-aa67-02ff37e9b63f',
        label: '4',
        disqualify: null,
      }, {
        id: '1ec3243d-7883-4090-a592-d452083fc16a',
        label: '5',
        disqualify: null,
      }],
    }, {
      id: '11fa09f9-908e-4c70-b666-f45a5aa660f0',
      label: 'How would you go about sharing the article on Twitter?',
      questionType: 'task',
      questionOrder: 14,
      groupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
      questionOptions: [],
    }, {
      id: '895a2694-6d57-4fcb-80b6-c1b08ce71dbb',
      label: 'Overall, this task was:',
      questionType: 'range',
      questionOrder: 15,
      groupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
      questionOptions: [{
        id: '4d8d7053-e777-4489-9eb6-6c4f4794f06d',
        label: '1',
        disqualify: null,
      }, {
        id: '6a3d4768-7f0a-4f0d-af52-0c733b0fb41f',
        label: '2',
        disqualify: null,
      }, {
        id: '8ed66f7a-042e-4187-9d68-aef5523b4d6d',
        label: '3',
        disqualify: null,
      }, {
        id: '45a897db-10b6-4d1a-b9eb-9f3e0ef1a958',
        label: '4',
        disqualify: null,
      }, {
        id: '18c1dfd3-f70b-4b0f-bc41-910dbebad91e',
        label: '5',
        disqualify: null,
      }],
    }],
  }, { // Screener - DONE
    id: 'a3202343-d999-466c-9930-4b4757ceb127',
    surveyType: 'screener',
    questions: [{
      id: '9e42de87-46a1-4852-8143-9cfd331201af',
      label: 'Do you perform user experience research?',
      questionType: 'single_select',
      questionOrder: null,
      groupId: null,
      questionOptions: [{
        id: '5107d7a7-d5dd-41cc-b4fe-e612927368b2',
        label: 'Never',
        disqualify: true,
      }, {
        id: '33db3fc5-9f74-4cf7-8e3d-43413eeb749d',
        label: '1 time per week',
        disqualify: true,
      }, {
        id: '6abb7b98-96ae-425a-83cf-7b45b95c8c54',
        label: '2-5 times per week',
        disqualify: false,
      }, {
        id: '0e9d784b-7e1b-46c9-9221-c988c4c9e332',
        label: '5+ time per week',
        disqualify: false,
      }],
    }],
  }],
  audienceAttributes: [{ // DONE
    id: 'a85258e6-3c0e-4d1f-9f81-bbe6e5134d44',
    audienceAttributeType: 'job_role',
    audienceAttributeOptions: [{
      id: '593e1554-a4d8-4244-b1ae-15058aa11aad',
      name: 'Product Manager',
    }, {
      id: '9be1c6b2-33f8-4e0c-8c78-edea090279da',
      name: 'User Research',
    }, {
      id: 'f461602e-adb4-45e6-b936-61eb85fc7db1',
      name: 'User Experience',
    }, {
      id: 'f9938f00-d3fe-4be1-be53-4f92205fb013',
      name: 'UX Design',
    }, {
      id: '0d4fccd3-dfd6-4cdf-93e1-805dd8e6ee44',
      name: 'Visual Design',
    }],
  }, {
    id: '9a5f6433-bffa-4e3c-ac03-69db46df53c5',
    audienceAttributeType: 'work_status',
    audienceAttributeOptions: [{
      id: '525faec0-88ac-4afb-933c-04bab8a06aa0',
      name: 'Full-Time',
    }, {
      id: 'e859e1bb-0c0f-432d-b93c-1240df6a7049',
      name: 'Part-Time',
    }],
  }],
  audienceParticipants: 5, // DONE
};

export const projectAnalyticsData = {
  quotes: [{
    quoteId: '898a0c20-1660-4b53-acff-900bc403e4f3',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: 'So medium is an article kind of resource.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '7830ee4b-162c-4249-8258-78832bf431bc',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "It's a web site for different articles.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '5db4c3aa-3b5e-41f4-add9-440977c7db56',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: 'And I think I were I really like reading them reading articles.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '319f899c-e7c7-4072-a3c9-4c7078ddd98c',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "I think one thing that's a little bit frustrating is that they get the pay wall pretty often.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'aff51b8f-0695-4fb8-a7bb-4e4da329d4da',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "So I don't like that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'ef27c7c1-b2c5-4669-8bdb-cc3e97033a5f',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "Of course, we I think it's for anyone can share their own article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '3d6bb72c-7ab5-4093-881a-896a9e6fc4ba',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "So it's not just written by one company.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '9eff9979-6f48-4816-a8e7-bd52720b87ac',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: 'They have stuff on all different eras or two spaces like startups or design or development.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '74b4c3ad-a8fa-4665-b58c-4abc090dbd83',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "And so yeah, it's really diverse types of Articles and they're all written by anyone kind of crowd sourcing of articles.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd7d0e42e-7e73-498c-aa18-dd943c12ac48',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "So the purpose of this page is to it's a looks like a home page for and a site that has a bunch of articles with a lot of different categories.",
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '836fe380-6adc-4331-993d-7dc83045f514',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: 'It looks like I can read about a lot of wide variety of things.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'aeec54f3-9dcd-4648-9c2e-4d1a91730675',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "I think So I'm looking at the design and it looks a little cluttered like it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '72ff54d5-0cb9-436a-8611-6ee12bc93db4',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "I'm not really a fan of this picture over here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'd68949c3-30c2-4793-9dcb-d4dd5a158915',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "That's kind of bleeding out into the side.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'f7048362-3180-4b26-bad1-ab340b00ff92',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "I'm not sure if that's a bug but there are a lot of columns.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'dd83527f-9631-425b-bc7a-1a9a0f93067b',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: 'There are three columns up here and then at that turns to two columns down here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'f9a911ed-ca7e-436e-a924-f553004ed966',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "So I'm not a huge fan of this design.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'b3c69216-bca4-442a-a414-fa45ca284eb5',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "Yes, I think there's website looks really trustworthy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'c86d5ab1-e674-4e5c-8ea3-cb05b85adb21',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "Maybe it's because I know of the brand and I've heard of the brand but it doesn't look spammy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '703ba503-a4b4-44fb-9c41-05e1a67960f8',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "I don't see ads anywhere.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd86ca920-4678-4721-bb9c-acc83a00f153',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "So usually when I think that something's not trustworthy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '4209f601-f229-416c-9e26-4556bfd3b4cf',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: 'I see a bunch of scam scam me types of ads.',
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'bc30efcf-b424-42a1-8d9d-7e646439b7b3',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "I don't say that here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '23c83735-c605-49c2-b6a4-791112238071',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: 'So I see a lot of just good quality content not not a lot of Click bait, so it does feel very trustworthy and reliable.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '20cf3590-7de2-467d-bc2a-a04714ffb3aa',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 2',
    sentence: 'This website feels pretty trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.7251,
    videoTime: 58029,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'bb7eed2e-f04b-49e2-8814-de8a189d90f6',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 2',
    sentence: "I think if I were to write content, I'd probably post on it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.7251,
    videoTime: 58029,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '3a350e18-e31d-4312-b4c5-3ca891579dfa',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 2',
    sentence: 'It seems like it is credible though, and I think I think that because of the clean design',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.7251,
    videoTime: 58029,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '3cae105d-fcb7-4f71-a524-1c1f4febef1a',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So if I was to find the article about ux what I would do, I would well first of all, I would go to the search bar and I would click so I have to sign in so I'll sign in now.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'edb799b8-c6b0-40dc-956b-da6c13e514d8',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'It looks like I have to start my membership.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'a094b238-2c02-4967-89a5-839b510a90aa',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So I'm not going to do that because I don't want to pay when I just want to try and find an article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '50c791f0-b126-4b44-8dd3-e75db286acdb',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So that's the one thing I find really frustrating about medium is the pay wall is so so quick that they make me pee really quickly.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'be42a222-4873-451b-aae5-a537ce6da978',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'I feel like other Publications.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'bd95a63d-0948-4316-bd0e-ccf5a4349abf',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'Typically, let me read a few more articles for I have to start clicking which is annoying.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'f01f8b25-761e-4d69-afab-81b413a427ae',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'So I would probably click design here at the top navigation.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'cd624c63-a74d-4fb7-ac78-9c96c0a70c46',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'I see an article says popular and design and says UI and ux Trend so I would click on that.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '6b193e6c-c466-46e3-ab5d-3bba6f8bdb79',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So now I'm in this article with ux Planet.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '2ff2c67d-991e-4960-99e6-dd4ee98c4b7e',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'So now I see here ux for beginners.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'de38eec1-edf9-4891-a557-a1d4e1803e0a',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'The header makes sense and I can find all different types of Articles here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'b07d00d8-098c-4629-86a0-78d3f3302d18',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So I guess it's just that when I tried to search I had to pay but if I wanted to just click from the home page, I was able to read articles without paying so I thought that's weird because it's not something typically I would see in any sort of other type of article news source that I read.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'ae417b66-09a0-43d3-98b4-9d5abb17f2b1',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "It's usually you can search freely or not prohibited from searching.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'c4b9ca1e-b550-4c8b-bbbe-486f3a756b64',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So I thought that was strange and I didn't really like that part, but I do like how I can read this article without having to pay which is nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'f8249cff-b4f3-4067-8eaf-7425884949c2',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 3',
    sentence: 'so if I want to view articles about ux, I would look for a search bar, which So the search bars kind of hidden, just let me search medium.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.7251,
    videoTime: 73522,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '92a8da75-71d5-447b-99c3-66186302602d',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 3',
    sentence: "I'm going to just write ux.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.7251,
    videoTime: 73522,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '32c88ace-b48a-4532-b30b-cf649a4e3383',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "So I think my impression of this page is it's very clean.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'cb652c82-febc-48a2-b883-8b890dda1c32',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "It's very simple, which is nice I can see, you know, here's different types of Articles again.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd0a7cc02-b3d3-4ad5-a0d5-68504aad3222',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "There's not ads on the side.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'e9b6dec2-3d9a-4cf3-be2f-7418e8e73561',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "There's not a lot of things here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd9cd3402-f45a-45c7-b695-c49c8ddd85b9',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "I get a little bit of social validation when I see the number of clicks claps, so that's nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '6f61f21f-e6fd-460e-8d1d-45bff643d8e9',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "So I like that you see the number of claps, but it's not overpowering so I know that other people like this article it's worth reading I see it's about 15 minutes to read which is nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fe1c3e7f-3cfd-4a29-b526-770b27f997f1',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "It doesn't take me too long, which is nice.But again, the navigation is a little confusing like I'm not totally sure where I would find other ux articles that are not in this one kind of ux planet article source of articles.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '9e3b4024-aadd-459d-9f87-34f5375285b3',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "So I'm on this ux page and it looks like I could search different tags.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '86558301-b4df-4e07-a48c-9fb3ed9bcfa8',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "So if I were to click on design or ux, I would filter down the Articles so I don't love what happened there.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '867f3619-e4f8-4852-b2d1-75c6f05a6fc4',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "I think there's just a lot of stuff.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'e491eb9d-5c75-43db-94ad-5dc0f7c0b6d8',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "There's they're trying to push a bunch of accounts on me to follow so I can get emails of it, but I'm a little overwhelmed by what's going on.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'd0bc0751-f6a2-4a50-a869-59c1c8d5300b',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "And then there's moving Parts in this image.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '247881bf-ade2-4866-8e33-804264d13947',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "So that's kind of frustrating.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'a724b2d2-9f7f-4a1c-88b4-6e28eb6db228',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 5',
    sentence: 'So if I was to find an article, that was 6 minutes long or maybe click on to user experience and I would scroll through the Articles here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.5,
    videoTime: 284190,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '2afbda06-49d5-450a-80bd-a081418db376',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 5',
    sentence: "They're nice little snapshots of each of the Articles and it says most of these are five minutes five minutes.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.5,
    videoTime: 284190,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'b22ecc61-8ec9-43a4-a7c7-5149407a7f18',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 5',
    sentence: 'Okay here, so I see designing the perfect search box is 6 minutes long, so I found that pretty quickly.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.5,
    videoTime: 284190,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '09bd861d-59ce-44cb-95b2-37e32d864046',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 5',
    sentence: " Well, that's kind of frustrating because it doesn't actually show that the read time.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.7251,
    videoTime: 156459,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '0eb43309-ee85-4b54-99ea-550150fd06ad',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 5',
    sentence: "And I would oh I see it kind of Blends in so I'm looking for something I found an article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.7251,
    videoTime: 156459,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '55e1697b-1c59-49e9-81b8-ffe52f884947',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 6',
    sentence: "So if I was to bookmark this page, so on my initial home screen, I don't see a way to bookmark it but then when I scroll down I do see this little save icon.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.5,
    videoTime: 330610,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fb0107af-629e-4d80-bead-c980f7670712',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 6',
    sentence: "So I would click the save icon and it looks like it's bookmarked.",
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.5,
    videoTime: 330610,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fd133d6d-3fde-40ea-b7c3-39ad19796ddd',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 6',
    sentence: "The only thing is I'm not exactly sure where I would go now to access that but for now, I think that seems pretty simple.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.5,
    videoTime: 330610,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '3216829f-b7d9-408e-bbdd-4515909617da',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: "so if I want to bookmark this so I can't really find a place to bookmark it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '8bf6667a-bc60-45ab-8e5c-0ddfe677f3b8',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: 'At first glance, but now I see one.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'd6245381-9508-49ab-9cc7-2aec15340fb1',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: 'Okay, so I could bookmark it here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '01a60b67-e2d8-4071-8767-25a3f940d175',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: "I'm going to click on that and yep.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fc7f0f85-f13c-48be-8213-98782e31d2b3',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: "Click on the bookmark basic because I'm already signed in it easily bookmarks it but I'm not exactly sure how to retrieve that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'a3f19846-d428-4330-9e01-7b0579932d4a',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: "If I go if I come back to my desk how I would actually retrieve that so it's kind of confusing and that regard I'd love to have something on the navigation that shows the bookmark.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '111bcb39-1fe7-4fe2-8a74-9981d3c70833',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: "so if I was to find The article so I'm going to go to my home kind of account settings here and scroll down.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '125acf8d-a1c1-4871-b412-0e0f9307826f',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: 'Okay, I see bookmarks is one of the account settings.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '16201967-4a52-4aba-8b0e-1983c22fdbb0',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: 'So that was fairly simple.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '5107744d-2345-4d3d-84fe-16a7eaccf42e',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: "I'd only had to do two clicks to get their actually not even so that was very easy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '825ab7dd-b61d-4e9b-b615-8f367b683daa',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 7',
    sentence: 'So if I were to find the article, I would go to k which is my initial know and I see bookmarks here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.7251,
    videoTime: 277214,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '1f431a33-e42a-472a-a902-ef191797228e',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 7',
    sentence: 'Okay, so the screen looks very bare, but I found it when I could see I see that I can remove it and I can click on it if I choose to read it.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.7251,
    videoTime: 277214,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'ff0175f1-fd69-4379-a7ec-5bda254d4b09',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 8',
    sentence: "So if I was to go to this article, I'm going to click back to the article and as I scroll down right next to the bookmark icon.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.5,
    videoTime: 409027,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '79cb65fc-8dfd-4afb-bdcd-e7152ff62e13',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 8',
    sentence: 'There is a Twitter icon.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.5,
    videoTime: 409027,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '9c3bd47f-d0c0-4ddb-9b38-5e0b139b2e67',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 8',
    sentence: 'So I would just click on that and it would give me an option to post on Twitter.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.5,
    videoTime: 409027,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '1a444de5-5f34-42f0-b3e7-318f12f125b9',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 8',
    sentence: 'So if I were to share this article, I would probably click on the article.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.7251,
    videoTime: 329342,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '88deaf46-eb5b-43fe-a7e1-da1cf1555bc7',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 8',
    sentence: 'And then on the sidebar, I would share it so I click Twitter.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.7251,
    videoTime: 329342,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '4cc01f33-cb53-4e29-a432-4bd0b63fbe6b',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: 'So I think the design looks clean.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '0c539a35-2614-4ca4-8df6-a5badea4e626',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '13dc07bb-89fb-4517-acac-9e758642faaa',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: 'I really like how simple it is.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '99d7df96-0d8a-40bb-945b-a4c1b8808c84',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: "You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'b339e0c5-896c-47d1-b043-66c556315829',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: 'Looks like it posts a bunch of stories and articles.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '7234db44-95cf-4286-a77e-107b98b57e8d',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: "I'm looks like I can sign up for it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'c9330648-e419-460a-b064-aab292b39ebe',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: "I feel pretty overwhelmed because there's a lot going on at this top.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '79ebfd91-ddff-409a-8e68-f65b2f4ba191',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: "I'm not really sure there seems like there's three columns of stories that are different heights and widths I guess they're the featured stories, but it's a little overwhelming and my eyes really aren't drawn to anything but it looks like I can read a bunch of Articles and view stories.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '79e2c43d-b311-4c21-b134-b9ac22d22682',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: 'This looks like a page where I could read articles.',
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '95b3d1af-8fd1-4ef4-9628-8644c9e82fc4',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: 'It looks like there are a ton of different categories that are all these different headers.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '0d62f2e9-d53f-4360-9986-e5fa5f6944a6',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: "It looks like they're featured articles that are being shown up top.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'd4023939-37f4-4aa4-b173-df5406285989',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: 'And it looks like I could sign up for these articles.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'd8f885d2-6f11-4e6e-9414-db172f5a5a29',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: 'I have this is website looks very trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '1d526bad-621a-4a31-9c21-6267733487ba',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "I feel like it looks very professional and I wouldn't I would like to read a lot of articles on here.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '13dc7a0d-df59-47a0-a0b8-4fad90980591',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "I don't see any ads.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'c5e70b9f-5726-4c74-8ed5-22f9e8323970',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "So I like how that it doesn't look like there's too many ads on on the page.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '859a35ce-1413-4f2d-8630-d688acc6fee4',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '600c08ef-bfff-4f5e-a14a-34c8f3a29a84',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 2',
    sentence: "I mean I wouldn't on not trust it but it's also not doesn't look that nice especially with the white background and just black font.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '6aded971-110e-4ec3-b79e-9e7e0fc60e6c',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 2',
    sentence: "It's it doesn't seem like a lot of But overall I think I would trust it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '51699e9a-fd5e-4d1c-a09c-32f6c37c17c2',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 2',
    sentence: "I probably wouldn't put it credit card information in but I trust it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '70d8ef3c-cbd4-4f1a-a2d1-c683bb474756',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 2',
    sentence: 'On this website seems trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: -0.5,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '15ff7de0-d199-486c-a3f8-aa6110d5f31d',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 2',
    sentence: 'It seems a little Bland with white background and black text but it does seem trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: -0.5,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '0038d3b9-6c8d-47f5-9a53-5f1f8374c53d',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 2',
    sentence: "I'm I've heard of this brand before and it looks like a ton of people right for them.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: -0.5,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '3236eacd-8d3d-40f3-816d-ba24eaf7c1b3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'e6b67280-ec6f-430a-aa23-189048604ab9',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'Right and here right away.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'e38b54d8-38c0-41d7-8758-b4112ed77c15',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '7e8d4f34-90de-41fd-9cad-a3ec3dd368e7',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So I like that I see a lot of content on ux and I also see on the right hand side tags.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '86856831-192b-4a3f-8c22-c5e080332e7c',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'And each of these I could the first thing is you asked which is exactly what I searched for.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'cf832104-be41-4616-a95c-3e0f261024c4',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'But I like how it also has the other related term to let other related keywords that may be associated with ux.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'ef0d123d-dfe8-489e-9976-effe3ed60943',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So design user experience UI so I like that had suggest options for me.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'ef066cd6-4c79-4fd6-84e3-afff0ef2e3a3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: "That's really nice and also suggest people that I could read.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '59792dc8-6b5a-496c-8ce6-7526edd715ed',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So these are kind of trusted sources I would say I would think that they are people who write about ux so I like that a lot as well as publication.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '5e13f558-06c6-4d66-a3f9-e47052c12a42',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So yeah like this is very easy.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '52ae8446-97c9-4304-9bfd-643a6bdc53cf',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: 'So if I want to view articles about ux I look at the top.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'aa51b1a8-4fae-4fc0-855e-cd75720fe900',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "Portion here, so I can't find anything that says ux or design.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '52570101-fa5f-4204-ab82-13869526c52f',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: 'Okay, so I accidentally put become a member.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '4e362b55-8710-4179-965c-f2ebd72f17c6',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: 'I thought that this become member was sort of in the search bar.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '31570fe2-524f-40a0-b903-19c9f061a85f',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '74fceacc-4e51-46c8-a380-0ba4916d5881',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "I'm not really sure the difference between people and Publications because I see the same icon here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'f447fd66-f6a9-470a-a8e8-5a649ea57638',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "So now I have this giant search don't think those very intuitive but that makes sense.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '5962038e-c116-4a0a-8b16-8ed13c3fae4a',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: 'If I want to view articles about ux, I think I would click on.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '0a705f18-d703-45d0-892c-7d7801d51a16',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "None of these categories really show you X so I'm going to click more.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '171f356b-53dd-4a1e-be18-1422f0a9d2d4',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "I'm going to scroll through so I don't think it's arts and entertainment.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'afc77dc1-922e-4efc-912e-fd6588b2d22f',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "So it's not an industry, which is a little weird.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '8a225db5-09ab-479a-b63e-294b17717440',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "Well, maybe it's design click on design.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '7d4a9606-c5b6-4882-af0b-942b160edde4',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "And I'm looking at related topics and says ux here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '6f8d7ee6-2308-4d24-a132-01f009e42af7',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: 'Now I have on a landing page.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '11faaa76-6270-484f-97da-ec04fe6b2edd',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: 'Now I have on a landing page.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'cfa75bcc-85bb-4090-a909-30cd7022e216',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "So on this page my impression is that it's pretty standard.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'f0425c19-436a-4bb3-953d-d5bbfa0ce394',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "I mean there's a lot.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'ac41d860-57d4-4e4c-8805-1d5666195264',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '449946d2-3378-4953-a554-39ae4c709ebf',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: 'I can see how many people commented on it and how long it takes to read and who it was from.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '2be00609-2ce4-4847-84e5-61e7132f4551',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "I don't know the difference between like ux and motion for ux Planet first prototype.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'd6b12332-b896-458a-9a83-a66114f84c0b',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "I don't know if those are different companies that are just publishing.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'e21ab710-ef93-4e1d-8386-82cca1904ef2',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "Information or if they're just different like segments of the article, so I'm a little confused on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '8469fd3b-c050-4ce1-b9ae-3b900c3d8667',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: 'My impression is that I could this page is that there are ton of Articles here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '61ef8c44-a5d6-4a52-8702-0adc855b6e0c',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: 'It looks like I could follow this entire category.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '62f7fe48-ecf8-4350-867f-b09404434d16',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: "It's weird that it says all about that user.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '63f12038-d657-4be8-8e46-fbf6e15b6f5a',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: "It doesn't really make sense because you X is in a user.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '713383a8-d43d-4e73-96ef-d05ea072d49a',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: "It's a industry so I can see the latest articles and then there's some featured writers.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'fff302c7-cba0-4544-8af2-92c0d408a377',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: 'I think I could read articles about ux and some of these images look a little weird.',
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '1b2b0b27-3dd7-4635-b1e6-452dc5291ae5',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 4',
    sentence: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0.6,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '922a81bc-0f20-4a30-9cd8-691d62b44ec3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 4',
    sentence: "So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0.6,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '4ba19708-86e0-4aa0-976a-76db237b0e7d',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 4',
    sentence: "So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0.6,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'f099f076-90b6-4274-b7b5-51f68c9f09e5',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "so if I'm looking for something that's around 6 minutes.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '6e4a24f7-8ed8-4550-ad74-a7c40439e556',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "It's really easy to see that here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '09599062-7e0c-401b-b714-43d723d2a3c3',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: 'I could see the title a little description the person and the date and then number of minutes to read.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'ad88e7eb-c050-4908-b94d-0900b5660683',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "I think it's a little weird.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '7e361083-df79-4c32-9dab-9d57dd4145eb',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "I'm not really sure what ux collected means or the startup.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '51a091ef-37fb-4c53-9f19-ee5ce0b51dee',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "I don't know if these are companies or just segments of different verticals within medium, but here's a six-minute article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'bd640580-f628-48ad-8095-505e49f64919',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "So I'm going to click on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '80a5bcd6-6a74-4d93-b3b4-2dc732a02118',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: " Okay, so at the top next to the person's name, it says the amount of time that the article is so I'm not seeing specifically six minutes, but I do see other length articles so I know that it I know where to find.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '631575fe-22d0-45f4-9f80-cfcd12ce5bf2',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: 'I just am not finding.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'e45d938d-9ba7-431c-a8cc-3dba89e24201',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: 'So I found this article redesigning the New York Times app you ask a study.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'ec5672fe-c0ef-4294-a9c4-a1638dfd3cc0',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: 'So I would click on that header here and that would open.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '1a6f3309-250d-4dac-98ec-b0b8f074e94e',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "So I'm about to run off to a meeting.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'a8c1c854-2f43-4169-8f28-121991b75b2f',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "I would look for something that is six minutes and okay, so I see one that's five minutes.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '65549588-0c1c-4b8a-82df-5361c9b1b79e',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: 'I see the five minutes up by the top of it.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '3124ba1e-674c-4f18-af41-7bea9d4661ae',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "I this is there's a huge disconnect between the picture with the person's name and the date and also the title, so I was a little confused on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'e0b2eeb6-8c51-49e7-84af-89ff7ecf944d',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: 'but So I see this one that is five minutes.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '5f37ba15-7483-41b6-8c49-ace2a0f11d66',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "So I'm going to click on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '65281207-0777-4713-b447-1929991b4cf3',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "I'm so I want to bookmark.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '004a5929-02dc-4212-abf8-ac1ad32dd805',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: 'This will look for a little bookmark icon.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'c8b68225-692c-4f3c-8abe-51410ccb6b0d',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '79406991-f567-48d3-9772-78eb98449034',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "I'm going to click bookmark.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '5a0d967d-5b87-4064-8db8-9822acfb540c',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "Okay, and now I'm going to sign in.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '1574fcb6-9387-430d-86aa-f2d5f46418e3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 6',
    sentence: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0.6,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '8a979d15-e9b9-4776-a22e-15f52a26ea77',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 6',
    sentence: "So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0.6,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '50fc8131-a804-4b46-8d14-6e4e53bc385f',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 6',
    sentence: 'So that was pretty easy for me to do.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0.6,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '298b2b5f-446c-499c-8e0d-8036491724aa',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 6',
    sentence: 'okay, so if I wanted to bookmark this let me see at the bottom of the page.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '136bd57d-dfc4-47ad-8b6c-0689a0f0e429',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 6',
    sentence: 'Okay, so I go to bookmark down here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '381b8448-b9ee-43db-b274-b915b4b4eaf9',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 6',
    sentence: "I'll click bookmark and I would sign up then I guess.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '74304dea-6568-489d-8d4b-bf4f62094b59',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 7',
    sentence: "So I'm back from my meeting and I want to find the article that I book marked.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '31245108-2b3a-4831-9f6e-74f5aaa599d8',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 7',
    sentence: 'This is my account settings.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'c13b534a-1cb6-40b2-8b8c-94b05e25c1ec',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 7',
    sentence: "I would assume so I could post a story not sure if the medium partner program is but it says bookmarks and now I see all the different things that I've bookmarked.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '2fbf2e0f-9937-4a3d-bfc7-abd7fffe0d91',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: "So to look for that bookmark article, I'm going to scroll to the footer.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '88dc833f-f0ce-4f05-9d93-d33c30dbc204',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: "And I don't think I can get there because the articles are just in a feed.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '751927c4-25c7-4dfd-b9be-09933048038e',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: 'So I go up to the top.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '8c745f0d-3201-425a-aec2-390ba64283d6',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: "I'm going to click on that icon with my initial in it and then look for bookmarks.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '3a87c274-45c6-48a9-a555-e8b077e690db',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: 'And I found that exact article.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '9d9c466a-f2c4-406c-a9e1-6922b2faf94c',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 7',
    sentence: 'Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0.6,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '9f42d301-e51c-498d-bb87-1c3189d8a958',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 7',
    sentence: "So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0.6,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '8794c104-05d4-461c-b507-365a062c92d3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 7',
    sentence: "I mean, I'm not sure how much it costs but I did like that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0.6,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'b1b0b9a3-92a7-48fc-8c61-1d61a5ac4c52',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: "So now I'm looking for a Twitter icon and I see it on the side of the panel.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '3014a884-be39-402d-a48f-5e755f8d84fe',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: 'I kind of wish it was it stood out a little more because the icons are all black.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '8153df05-7a08-4abf-831c-28e62a7da3bf',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: "So it maybe it'd be nice to just have an outline.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'd6a4b396-6e16-4ba1-9d18-9fb4d8058cec',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: "That's the Twitter color and an outline of the Facebook.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'f94deea1-0fa5-49c8-89dd-53c51f7310b1',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: 'Go back to this article.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '4412f30a-a3c8-4d8f-93fc-f1dcb1a8d503',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: 'So right underneath the book Mark page, there is a Twitter icon.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '27332e3e-3d2a-48c2-ba6f-e574390e0fb4',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: "So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'a62dc60e-9096-4cf4-9d66-ec734f0dd589',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: 'So I would just click login and tweet.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'cf26fa3d-b565-414b-bcb2-602d20b4d0e3',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 8',
    sentence: "So if I want to share this article on Twitter, I would look so it's as soon as I explore all down.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'e55e21c8-1b73-4a04-b8c0-128311e54a28',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 8',
    sentence: 'I see the social icons.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'd30fdaa3-a1b5-4ff1-adc1-0717eaf4199d',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 8',
    sentence: 'So I put Twitter and I shared on Twitter then.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }],
};

export const analyticsData = {
  country: [{
    label: 'CA',
    qty: 2,
  }, {
    label: 'NY',
    qty: 1,
  }, {
    label: 'NJ',
    qty: 1,
  }, {
    label: 'NV',
    qty: 1,
  }],
  ageRange: [{
    label: '21-29',
    qty: 2,
  }, {
    label: '30-39',
    qty: 2,
  }, {
    label: '40-54',
    qty: 1,
  }],
  raceEthnicHeritage: [{
    label: 'Black or African American',
    qty: 2,
  }, {
    label: 'White / Caucasian',
    qty: 2,
  }, {
    label: 'Asian or Pacific Islander',
    qty: 1,
  }],
  gender: [{
    label: 'Male',
    qty: 3,
  }, {
    label: 'Female',
    qty: 2,
  }],
  annualHouseholdIncome: [{
    label: '$100,001-$150,000',
    qty: 3,
  }, {
    label: '$200,001-$300,000',
    qty: 2,
  }],
  jobTitle: [{
    label: 'Product Manager',
    qty: 1,
  }, {
    label: 'UI Design Lead',
    qty: 1,
  }, {
    label: 'Sr. Product Manager',
    qty: 1,
  }, {
    label: 'Director of UX Research',
    qty: 1,
  }, {
    label: 'UX Manager',
    qty: 1,
  }],
  industry: [{
    label: 'Internet',
    qty: 3,
  }, {
    label: 'E-Learning',
    qty: 1,
  }, {
    label: 'Information Services',
    qty: 1,
  }],
  seniority: [{
    label: 'Manager',
    qty: 2,
  }, {
    label: 'Entry-Level',
    qty: 1,
  }, {
    label: 'Senior',
    qty: 1,
  }, {
    label: 'Director',
    qty: 1,
  }],
  companySize: [{
    label: '10,001+',
    qty: 2,
  }, {
    label: '201-500',
    qty: 1,
  }, {
    label: '501-1000',
    qty: 1,
  }, {
    label: '1001-5000',
    qty: 1,
  }],
  taskDifficulty: [{
    firstName: 'Lance',
    lastName: 'Doe',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionOrder: 10,
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    difficulty: 5,
    difficultyPerTask: 4.333333333333333,
  }, {
    firstName: 'John',
    lastName: 'Doe',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionOrder: 10,
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    difficulty: 3,
    difficultyPerTask: 4.333333333333333,
  }, {
    firstName: 'Mason',
    lastName: 'Doe',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionOrder: 10,
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    difficulty: 5,
    difficultyPerTask: 4.333333333333333,
  }, {
    firstName: 'Mason',
    lastName: 'Doe',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionOrder: 5,
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    difficulty: 3,
    difficultyPerTask: 3.3333333333333335,
  }, {
    firstName: 'John',
    lastName: 'Doe',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionOrder: 5,
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    difficulty: 2,
    difficultyPerTask: 3.3333333333333335,
  }, {
    firstName: 'Lance',
    lastName: 'Doe',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionOrder: 5,
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    difficulty: 5,
    difficultyPerTask: 3.3333333333333335,
  }, {
    firstName: 'Mason',
    lastName: 'Doe',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionOrder: 13,
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    difficulty: 5,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'John',
    lastName: 'Doe',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionOrder: 13,
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    difficulty: 4,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'Lance',
    lastName: 'Doe',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionOrder: 13,
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    difficulty: 5,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'Lance',
    lastName: 'Doe',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionOrder: 8,
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    difficulty: 5,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'John',
    lastName: 'Doe',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionOrder: 8,
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    difficulty: 4,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'Mason',
    lastName: 'Doe',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionOrder: 8,
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    difficulty: 5,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'Mason',
    lastName: 'Doe',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionOrder: 15,
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    difficulty: 5,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'John',
    lastName: 'Doe',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionOrder: 15,
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    difficulty: 4,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'Lance',
    lastName: 'Doe',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionOrder: 15,
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    difficulty: 5,
    difficultyPerTask: 4.666666666666667,
  }, {
    firstName: 'Ashley',
    lastName: 'Doe',
    testerId: 'b081d6e0-99bd-45b2-8ba6-f0ec2783e398',
    questionOrder: 13,
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    difficulty: 4,
    difficultyPerTask: 4.5,
  }, {
    firstName: 'Jill',
    lastName: 'Doe',
    testerId: '38b53fa6-d14d-4dbc-b717-b318749f6243',
    questionOrder: 13,
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    difficulty: 5,
    difficultyPerTask: 4.5,
  }, {
    firstName: 'Ashley',
    lastName: 'Doe',
    testerId: 'b081d6e0-99bd-45b2-8ba6-f0ec2783e398',
    questionOrder: 8,
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    difficulty: 3,
    difficultyPerTask: 4.0,
  }, {
    firstName: 'Jill',
    lastName: 'Doe',
    testerId: '38b53fa6-d14d-4dbc-b717-b318749f6243',
    questionOrder: 8,
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    difficulty: 5,
    difficultyPerTask: 4.0,
  }, {
    firstName: 'Ashley',
    lastName: 'Doe',
    testerId: 'b081d6e0-99bd-45b2-8ba6-f0ec2783e398',
    questionOrder: 10,
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    difficulty: 4,
    difficultyPerTask: 4.5,
  }, {
    firstName: 'Jill',
    lastName: 'Doe',
    testerId: '38b53fa6-d14d-4dbc-b717-b318749f6243',
    questionOrder: 10,
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    difficulty: 5,
    difficultyPerTask: 4.5,
  }, {
    firstName: 'Jill',
    lastName: 'Doe',
    testerId: '38b53fa6-d14d-4dbc-b717-b318749f6243',
    questionOrder: 15,
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    difficulty: 5,
    difficultyPerTask: 5.0,
  }, {
    firstName: 'Ashley',
    lastName: 'Doe',
    testerId: 'b081d6e0-99bd-45b2-8ba6-f0ec2783e398',
    questionOrder: 15,
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    difficulty: 5,
    difficultyPerTask: 5.0,
  }, {
    firstName: 'Ashley',
    lastName: 'Doe',
    testerId: 'b081d6e0-99bd-45b2-8ba6-f0ec2783e398',
    questionOrder: 5,
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    difficulty: 4,
    difficultyPerTask: 3.0,
  }, {
    firstName: 'Jill',
    lastName: 'Doe',
    testerId: '38b53fa6-d14d-4dbc-b717-b318749f6243',
    questionOrder: 5,
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    difficulty: 2,
    difficultyPerTask: 3.0,
  }],
  quotes: [{
    quoteId: '898a0c20-1660-4b53-acff-900bc403e4f3',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: 'So medium is an article kind of resource.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '7830ee4b-162c-4249-8258-78832bf431bc',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "It's a web site for different articles.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '5db4c3aa-3b5e-41f4-add9-440977c7db56',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: 'And I think I were I really like reading them reading articles.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '319f899c-e7c7-4072-a3c9-4c7078ddd98c',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "I think one thing that's a little bit frustrating is that they get the pay wall pretty often.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'aff51b8f-0695-4fb8-a7bb-4e4da329d4da',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "So I don't like that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'ef27c7c1-b2c5-4669-8bdb-cc3e97033a5f',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "Of course, we I think it's for anyone can share their own article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '3d6bb72c-7ab5-4093-881a-896a9e6fc4ba',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "So it's not just written by one company.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '9eff9979-6f48-4816-a8e7-bd52720b87ac',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: 'They have stuff on all different eras or two spaces like startups or design or development.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '74b4c3ad-a8fa-4665-b58c-4abc090dbd83',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 1',
    sentence: "And so yeah, it's really diverse types of Articles and they're all written by anyone kind of crowd sourcing of articles.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.5,
    videoTime: 6225,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd7d0e42e-7e73-498c-aa18-dd943c12ac48',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "So the purpose of this page is to it's a looks like a home page for and a site that has a bunch of articles with a lot of different categories.",
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '836fe380-6adc-4331-993d-7dc83045f514',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: 'It looks like I can read about a lot of wide variety of things.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'aeec54f3-9dcd-4648-9c2e-4d1a91730675',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "I think So I'm looking at the design and it looks a little cluttered like it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '72ff54d5-0cb9-436a-8611-6ee12bc93db4',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "I'm not really a fan of this picture over here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'd68949c3-30c2-4793-9dcb-d4dd5a158915',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "That's kind of bleeding out into the side.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'f7048362-3180-4b26-bad1-ab340b00ff92',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "I'm not sure if that's a bug but there are a lot of columns.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'dd83527f-9631-425b-bc7a-1a9a0f93067b',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: 'There are three columns up here and then at that turns to two columns down here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'f9a911ed-ca7e-436e-a924-f553004ed966',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 1',
    sentence: "So I'm not a huge fan of this design.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9215,
    sentimentByParticipant: 0.7251,
    videoTime: 5562,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'b3c69216-bca4-442a-a414-fa45ca284eb5',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "Yes, I think there's website looks really trustworthy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'c86d5ab1-e674-4e5c-8ea3-cb05b85adb21',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "Maybe it's because I know of the brand and I've heard of the brand but it doesn't look spammy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '703ba503-a4b4-44fb-9c41-05e1a67960f8',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "I don't see ads anywhere.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd86ca920-4678-4721-bb9c-acc83a00f153',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "So usually when I think that something's not trustworthy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '4209f601-f229-416c-9e26-4556bfd3b4cf',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: 'I see a bunch of scam scam me types of ads.',
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'bc30efcf-b424-42a1-8d9d-7e646439b7b3',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: "I don't say that here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '23c83735-c605-49c2-b6a4-791112238071',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 2',
    sentence: 'So I see a lot of just good quality content not not a lot of Click bait, so it does feel very trustworthy and reliable.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.5,
    videoTime: 57891,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '20cf3590-7de2-467d-bc2a-a04714ffb3aa',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 2',
    sentence: 'This website feels pretty trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.7251,
    videoTime: 58029,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'bb7eed2e-f04b-49e2-8814-de8a189d90f6',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 2',
    sentence: "I think if I were to write content, I'd probably post on it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.7251,
    videoTime: 58029,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '3a350e18-e31d-4312-b4c5-3ca891579dfa',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 2',
    sentence: 'It seems like it is credible though, and I think I think that because of the clean design',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9136,
    sentimentByParticipant: 0.7251,
    videoTime: 58029,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '3cae105d-fcb7-4f71-a524-1c1f4febef1a',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So if I was to find the article about ux what I would do, I would well first of all, I would go to the search bar and I would click so I have to sign in so I'll sign in now.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'edb799b8-c6b0-40dc-956b-da6c13e514d8',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'It looks like I have to start my membership.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'a094b238-2c02-4967-89a5-839b510a90aa',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So I'm not going to do that because I don't want to pay when I just want to try and find an article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '50c791f0-b126-4b44-8dd3-e75db286acdb',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So that's the one thing I find really frustrating about medium is the pay wall is so so quick that they make me pee really quickly.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'be42a222-4873-451b-aae5-a537ce6da978',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'I feel like other Publications.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'bd95a63d-0948-4316-bd0e-ccf5a4349abf',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'Typically, let me read a few more articles for I have to start clicking which is annoying.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'f01f8b25-761e-4d69-afab-81b413a427ae',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'So I would probably click design here at the top navigation.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'cd624c63-a74d-4fb7-ac78-9c96c0a70c46',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'I see an article says popular and design and says UI and ux Trend so I would click on that.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '6b193e6c-c466-46e3-ab5d-3bba6f8bdb79',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So now I'm in this article with ux Planet.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '2ff2c67d-991e-4960-99e6-dd4ee98c4b7e',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'So now I see here ux for beginners.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'de38eec1-edf9-4891-a557-a1d4e1803e0a',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: 'The header makes sense and I can find all different types of Articles here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'b07d00d8-098c-4629-86a0-78d3f3302d18',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So I guess it's just that when I tried to search I had to pay but if I wanted to just click from the home page, I was able to read articles without paying so I thought that's weird because it's not something typically I would see in any sort of other type of article news source that I read.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'ae417b66-09a0-43d3-98b4-9d5abb17f2b1',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "It's usually you can search freely or not prohibited from searching.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'c4b9ca1e-b550-4c8b-bbbe-486f3a756b64',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 3',
    sentence: "So I thought that was strange and I didn't really like that part, but I do like how I can read this article without having to pay which is nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.5,
    videoTime: 92737,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'f8249cff-b4f3-4067-8eaf-7425884949c2',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 3',
    sentence: 'so if I want to view articles about ux, I would look for a search bar, which So the search bars kind of hidden, just let me search medium.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.7251,
    videoTime: 73522,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '92a8da75-71d5-447b-99c3-66186302602d',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 3',
    sentence: "I'm going to just write ux.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9491,
    sentimentByParticipant: 0.7251,
    videoTime: 73522,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '32c88ace-b48a-4532-b30b-cf649a4e3383',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "So I think my impression of this page is it's very clean.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'cb652c82-febc-48a2-b883-8b890dda1c32',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "It's very simple, which is nice I can see, you know, here's different types of Articles again.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd0a7cc02-b3d3-4ad5-a0d5-68504aad3222',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "There's not ads on the side.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'e9b6dec2-3d9a-4cf3-be2f-7418e8e73561',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "There's not a lot of things here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'd9cd3402-f45a-45c7-b695-c49c8ddd85b9',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "I get a little bit of social validation when I see the number of clicks claps, so that's nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '6f61f21f-e6fd-460e-8d1d-45bff643d8e9',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "So I like that you see the number of claps, but it's not overpowering so I know that other people like this article it's worth reading I see it's about 15 minutes to read which is nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fe1c3e7f-3cfd-4a29-b526-770b27f997f1',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 4',
    sentence: "It doesn't take me too long, which is nice.But again, the navigation is a little confusing like I'm not totally sure where I would find other ux articles that are not in this one kind of ux planet article source of articles.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.5,
    videoTime: 217136,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '9e3b4024-aadd-459d-9f87-34f5375285b3',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "So I'm on this ux page and it looks like I could search different tags.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '86558301-b4df-4e07-a48c-9fb3ed9bcfa8',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "So if I were to click on design or ux, I would filter down the Articles so I don't love what happened there.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '867f3619-e4f8-4852-b2d1-75c6f05a6fc4',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "I think there's just a lot of stuff.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'e491eb9d-5c75-43db-94ad-5dc0f7c0b6d8',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "There's they're trying to push a bunch of accounts on me to follow so I can get emails of it, but I'm a little overwhelmed by what's going on.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'd0bc0751-f6a2-4a50-a869-59c1c8d5300b',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "And then there's moving Parts in this image.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '247881bf-ade2-4866-8e33-804264d13947',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 4',
    sentence: "So that's kind of frustrating.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9862,
    sentimentByParticipant: 0.7251,
    videoTime: 106685,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'a724b2d2-9f7f-4a1c-88b4-6e28eb6db228',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 5',
    sentence: 'So if I was to find an article, that was 6 minutes long or maybe click on to user experience and I would scroll through the Articles here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.5,
    videoTime: 284190,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '2afbda06-49d5-450a-80bd-a081418db376',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 5',
    sentence: "They're nice little snapshots of each of the Articles and it says most of these are five minutes five minutes.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.5,
    videoTime: 284190,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'b22ecc61-8ec9-43a4-a7c7-5149407a7f18',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 5',
    sentence: 'Okay here, so I see designing the perfect search box is 6 minutes long, so I found that pretty quickly.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.5,
    videoTime: 284190,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '09bd861d-59ce-44cb-95b2-37e32d864046',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 5',
    sentence: " Well, that's kind of frustrating because it doesn't actually show that the read time.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.7251,
    videoTime: 156459,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '0eb43309-ee85-4b54-99ea-550150fd06ad',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 5',
    sentence: "And I would oh I see it kind of Blends in so I'm looking for something I found an article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8927,
    sentimentByParticipant: 0.7251,
    videoTime: 156459,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '55e1697b-1c59-49e9-81b8-ffe52f884947',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 6',
    sentence: "So if I was to bookmark this page, so on my initial home screen, I don't see a way to bookmark it but then when I scroll down I do see this little save icon.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.5,
    videoTime: 330610,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fb0107af-629e-4d80-bead-c980f7670712',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 6',
    sentence: "So I would click the save icon and it looks like it's bookmarked.",
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.5,
    videoTime: 330610,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fd133d6d-3fde-40ea-b7c3-39ad19796ddd',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 6',
    sentence: "The only thing is I'm not exactly sure where I would go now to access that but for now, I think that seems pretty simple.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.5,
    videoTime: 330610,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '3216829f-b7d9-408e-bbdd-4515909617da',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: "so if I want to bookmark this so I can't really find a place to bookmark it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '8bf6667a-bc60-45ab-8e5c-0ddfe677f3b8',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: 'At first glance, but now I see one.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'd6245381-9508-49ab-9cc7-2aec15340fb1',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: 'Okay, so I could bookmark it here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '01a60b67-e2d8-4071-8767-25a3f940d175',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: "I'm going to click on that and yep.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: 'fc7f0f85-f13c-48be-8213-98782e31d2b3',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: "Click on the bookmark basic because I'm already signed in it easily bookmarks it but I'm not exactly sure how to retrieve that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'a3f19846-d428-4330-9e01-7b0579932d4a',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 6',
    sentence: "If I go if I come back to my desk how I would actually retrieve that so it's kind of confusing and that regard I'd love to have something on the navigation that shows the bookmark.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9785,
    sentimentByParticipant: 0.7251,
    videoTime: 205964,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '111bcb39-1fe7-4fe2-8a74-9981d3c70833',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: "so if I was to find The article so I'm going to go to my home kind of account settings here and scroll down.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '125acf8d-a1c1-4871-b412-0e0f9307826f',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: 'Okay, I see bookmarks is one of the account settings.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '16201967-4a52-4aba-8b0e-1983c22fdbb0',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: 'So that was fairly simple.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '5107744d-2345-4d3d-84fe-16a7eaccf42e',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 7',
    sentence: "I'd only had to do two clicks to get their actually not even so that was very easy.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.5,
    videoTime: 372271,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '825ab7dd-b61d-4e9b-b615-8f367b683daa',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 7',
    sentence: 'So if I were to find the article, I would go to k which is my initial know and I see bookmarks here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.7251,
    videoTime: 277214,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '1f431a33-e42a-472a-a902-ef191797228e',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 7',
    sentence: 'Okay, so the screen looks very bare, but I found it when I could see I see that I can remove it and I can click on it if I choose to read it.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8717,
    sentimentByParticipant: 0.7251,
    videoTime: 277214,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: 'ff0175f1-fd69-4379-a7ec-5bda254d4b09',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 8',
    sentence: "So if I was to go to this article, I'm going to click back to the article and as I scroll down right next to the bookmark icon.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.5,
    videoTime: 409027,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '79cb65fc-8dfd-4afb-bdcd-e7152ff62e13',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 8',
    sentence: 'There is a Twitter icon.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.5,
    videoTime: 409027,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '9c3bd47f-d0c0-4ddb-9b38-5e0b139b2e67',
    testerId: 'aafeaa0b-ba41-4510-9d40-220856604d80',
    questionGroupName: 'Task 8',
    sentence: 'So I would just click on that and it would give me an option to post on Twitter.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.5,
    videoTime: 409027,
    firstName: 'Jill',
    lastName: 'Doe',
  }, {
    quoteId: '1a444de5-5f34-42f0-b3e7-318f12f125b9',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 8',
    sentence: 'So if I were to share this article, I would probably click on the article.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.7251,
    videoTime: 329342,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '88deaf46-eb5b-43fe-a7e1-da1cf1555bc7',
    testerId: '45d5b006-1d04-4b65-9e6a-d855c53b2417',
    questionGroupName: 'Task 8',
    sentence: 'And then on the sidebar, I would share it so I click Twitter.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.5267,
    sentimentByParticipant: 0.7251,
    videoTime: 329342,
    firstName: 'Ashley',
    lastName: 'Doe',
  }, {
    quoteId: '4cc01f33-cb53-4e29-a432-4bd0b63fbe6b',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: 'So I think the design looks clean.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '0c539a35-2614-4ca4-8df6-a5badea4e626',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '13dc07bb-89fb-4517-acac-9e758642faaa',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: 'I really like how simple it is.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '99d7df96-0d8a-40bb-945b-a4c1b8808c84',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 1',
    sentence: "You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0.6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'b339e0c5-896c-47d1-b043-66c556315829',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: 'Looks like it posts a bunch of stories and articles.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '7234db44-95cf-4286-a77e-107b98b57e8d',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: "I'm looks like I can sign up for it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'c9330648-e419-460a-b064-aab292b39ebe',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: "I feel pretty overwhelmed because there's a lot going on at this top.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '79ebfd91-ddff-409a-8e68-f65b2f4ba191',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 1',
    sentence: "I'm not really sure there seems like there's three columns of stories that are different heights and widths I guess they're the featured stories, but it's a little overwhelming and my eyes really aren't drawn to anything but it looks like I can read a bunch of Articles and view stories.",
    important: true,
    removed: false,
    sentimentBySentence: 'Negative',
    sentimentByTask: 0.9904,
    sentimentByParticipant: 0,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '79e2c43d-b311-4c21-b134-b9ac22d22682',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: 'This looks like a page where I could read articles.',
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '95b3d1af-8fd1-4ef4-9628-8644c9e82fc4',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: 'It looks like there are a ton of different categories that are all these different headers.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '0d62f2e9-d53f-4360-9986-e5fa5f6944a6',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: "It looks like they're featured articles that are being shown up top.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'd4023939-37f4-4aa4-b173-df5406285989',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 1',
    sentence: 'And it looks like I could sign up for these articles.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9904,
    sentimentByParticipant: -0.5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'd8f885d2-6f11-4e6e-9414-db172f5a5a29',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: 'I have this is website looks very trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '1d526bad-621a-4a31-9c21-6267733487ba',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "I feel like it looks very professional and I wouldn't I would like to read a lot of articles on here.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '13dc7a0d-df59-47a0-a0b8-4fad90980591',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "I don't see any ads.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'c5e70b9f-5726-4c74-8ed5-22f9e8323970',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "So I like how that it doesn't look like there's too many ads on on the page.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '859a35ce-1413-4f2d-8630-d688acc6fee4',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 2',
    sentence: "Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0.6,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '600c08ef-bfff-4f5e-a14a-34c8f3a29a84',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 2',
    sentence: "I mean I wouldn't on not trust it but it's also not doesn't look that nice especially with the white background and just black font.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '6aded971-110e-4ec3-b79e-9e7e0fc60e6c',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 2',
    sentence: "It's it doesn't seem like a lot of But overall I think I would trust it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '51699e9a-fd5e-4d1c-a09c-32f6c37c17c2',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 2',
    sentence: "I probably wouldn't put it credit card information in but I trust it.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: 0,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '70d8ef3c-cbd4-4f1a-a2d1-c683bb474756',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 2',
    sentence: 'On this website seems trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: -0.5,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '15ff7de0-d199-486c-a3f8-aa6110d5f31d',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 2',
    sentence: 'It seems a little Bland with white background and black text but it does seem trustworthy.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: -0.5,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '0038d3b9-6c8d-47f5-9a53-5f1f8374c53d',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 2',
    sentence: "I'm I've heard of this brand before and it looks like a ton of people right for them.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9959,
    sentimentByParticipant: -0.5,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '3236eacd-8d3d-40f3-816d-ba24eaf7c1b3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'e6b67280-ec6f-430a-aa23-189048604ab9',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'Right and here right away.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'e38b54d8-38c0-41d7-8758-b4112ed77c15',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '7e8d4f34-90de-41fd-9cad-a3ec3dd368e7',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So I like that I see a lot of content on ux and I also see on the right hand side tags.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '86856831-192b-4a3f-8c22-c5e080332e7c',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'And each of these I could the first thing is you asked which is exactly what I searched for.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'cf832104-be41-4616-a95c-3e0f261024c4',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'But I like how it also has the other related term to let other related keywords that may be associated with ux.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'ef0d123d-dfe8-489e-9976-effe3ed60943',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So design user experience UI so I like that had suggest options for me.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'ef066cd6-4c79-4fd6-84e3-afff0ef2e3a3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: "That's really nice and also suggest people that I could read.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '59792dc8-6b5a-496c-8ce6-7526edd715ed',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So these are kind of trusted sources I would say I would think that they are people who write about ux so I like that a lot as well as publication.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '5e13f558-06c6-4d66-a3f9-e47052c12a42',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 3',
    sentence: 'So yeah like this is very easy.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0.6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '52ae8446-97c9-4304-9bfd-643a6bdc53cf',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: 'So if I want to view articles about ux I look at the top.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'aa51b1a8-4fae-4fc0-855e-cd75720fe900',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "Portion here, so I can't find anything that says ux or design.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '52570101-fa5f-4204-ab82-13869526c52f',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: 'Okay, so I accidentally put become a member.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '4e362b55-8710-4179-965c-f2ebd72f17c6',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: 'I thought that this become member was sort of in the search bar.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '31570fe2-524f-40a0-b903-19c9f061a85f',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '74fceacc-4e51-46c8-a380-0ba4916d5881',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "I'm not really sure the difference between people and Publications because I see the same icon here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'f447fd66-f6a9-470a-a8e8-5a649ea57638',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 3',
    sentence: "So now I have this giant search don't think those very intuitive but that makes sense.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: 0,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '5962038e-c116-4a0a-8b16-8ed13c3fae4a',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: 'If I want to view articles about ux, I think I would click on.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '0a705f18-d703-45d0-892c-7d7801d51a16',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "None of these categories really show you X so I'm going to click more.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '171f356b-53dd-4a1e-be18-1422f0a9d2d4',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "I'm going to scroll through so I don't think it's arts and entertainment.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'afc77dc1-922e-4efc-912e-fd6588b2d22f',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "So it's not an industry, which is a little weird.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '8a225db5-09ab-479a-b63e-294b17717440',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "Well, maybe it's design click on design.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '7d4a9606-c5b6-4882-af0b-942b160edde4',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: "And I'm looking at related topics and says ux here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '6f8d7ee6-2308-4d24-a132-01f009e42af7',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: 'Now I have on a landing page.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '11faaa76-6270-484f-97da-ec04fe6b2edd',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 3',
    sentence: 'Now I have on a landing page.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9949,
    sentimentByParticipant: -0.5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'cfa75bcc-85bb-4090-a909-30cd7022e216',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "So on this page my impression is that it's pretty standard.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'f0425c19-436a-4bb3-953d-d5bbfa0ce394',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "I mean there's a lot.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'ac41d860-57d4-4e4c-8805-1d5666195264',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '449946d2-3378-4953-a554-39ae4c709ebf',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: 'I can see how many people commented on it and how long it takes to read and who it was from.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '2be00609-2ce4-4847-84e5-61e7132f4551',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "I don't know the difference between like ux and motion for ux Planet first prototype.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'd6b12332-b896-458a-9a83-a66114f84c0b',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "I don't know if those are different companies that are just publishing.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'e21ab710-ef93-4e1d-8386-82cca1904ef2',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 4',
    sentence: "Information or if they're just different like segments of the article, so I'm a little confused on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '8469fd3b-c050-4ce1-b9ae-3b900c3d8667',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: 'My impression is that I could this page is that there are ton of Articles here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '61ef8c44-a5d6-4a52-8702-0adc855b6e0c',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: 'It looks like I could follow this entire category.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '62f7fe48-ecf8-4350-867f-b09404434d16',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: "It's weird that it says all about that user.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '63f12038-d657-4be8-8e46-fbf6e15b6f5a',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: "It doesn't really make sense because you X is in a user.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '713383a8-d43d-4e73-96ef-d05ea072d49a',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: "It's a industry so I can see the latest articles and then there's some featured writers.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'fff302c7-cba0-4544-8af2-92c0d408a377',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 4',
    sentence: 'I think I could read articles about ux and some of these images look a little weird.',
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: -0.5,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '1b2b0b27-3dd7-4635-b1e6-452dc5291ae5',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 4',
    sentence: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0.6,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '922a81bc-0f20-4a30-9cd8-691d62b44ec3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 4',
    sentence: "So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0.6,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '4ba19708-86e0-4aa0-976a-76db237b0e7d',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 4',
    sentence: "So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9912,
    sentimentByParticipant: 0.6,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'f099f076-90b6-4274-b7b5-51f68c9f09e5',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "so if I'm looking for something that's around 6 minutes.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '6e4a24f7-8ed8-4550-ad74-a7c40439e556',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "It's really easy to see that here.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '09599062-7e0c-401b-b714-43d723d2a3c3',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: 'I could see the title a little description the person and the date and then number of minutes to read.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'ad88e7eb-c050-4908-b94d-0900b5660683',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "I think it's a little weird.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '7e361083-df79-4c32-9dab-9d57dd4145eb',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "I'm not really sure what ux collected means or the startup.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '51a091ef-37fb-4c53-9f19-ee5ce0b51dee',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "I don't know if these are companies or just segments of different verticals within medium, but here's a six-minute article.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'bd640580-f628-48ad-8095-505e49f64919',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 5',
    sentence: "So I'm going to click on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: -0.5,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '80a5bcd6-6a74-4d93-b3b4-2dc732a02118',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: " Okay, so at the top next to the person's name, it says the amount of time that the article is so I'm not seeing specifically six minutes, but I do see other length articles so I know that it I know where to find.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '631575fe-22d0-45f4-9f80-cfcd12ce5bf2',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: 'I just am not finding.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'e45d938d-9ba7-431c-a8cc-3dba89e24201',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: 'So I found this article redesigning the New York Times app you ask a study.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'ec5672fe-c0ef-4294-a9c4-a1638dfd3cc0',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 5',
    sentence: 'So I would click on that header here and that would open.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0.6,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '1a6f3309-250d-4dac-98ec-b0b8f074e94e',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "So I'm about to run off to a meeting.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'a8c1c854-2f43-4169-8f28-121991b75b2f',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "I would look for something that is six minutes and okay, so I see one that's five minutes.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '65549588-0c1c-4b8a-82df-5361c9b1b79e',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: 'I see the five minutes up by the top of it.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '3124ba1e-674c-4f18-af41-7bea9d4661ae',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "I this is there's a huge disconnect between the picture with the person's name and the date and also the title, so I was a little confused on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'e0b2eeb6-8c51-49e7-84af-89ff7ecf944d',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: 'but So I see this one that is five minutes.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '5f37ba15-7483-41b6-8c49-ace2a0f11d66',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 5',
    sentence: "So I'm going to click on that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.8734,
    sentimentByParticipant: 0,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '65281207-0777-4713-b447-1929991b4cf3',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "I'm so I want to bookmark.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '004a5929-02dc-4212-abf8-ac1ad32dd805',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: 'This will look for a little bookmark icon.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'c8b68225-692c-4f3c-8abe-51410ccb6b0d',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    important: true,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '79406991-f567-48d3-9772-78eb98449034',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "I'm going to click bookmark.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '5a0d967d-5b87-4064-8db8-9822acfb540c',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 6',
    sentence: "Okay, and now I'm going to sign in.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: -0.5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '1574fcb6-9387-430d-86aa-f2d5f46418e3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 6',
    sentence: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0.6,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '8a979d15-e9b9-4776-a22e-15f52a26ea77',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 6',
    sentence: "So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0.6,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '50fc8131-a804-4b46-8d14-6e4e53bc385f',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 6',
    sentence: 'So that was pretty easy for me to do.',
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0.6,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '298b2b5f-446c-499c-8e0d-8036491724aa',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 6',
    sentence: 'okay, so if I wanted to bookmark this let me see at the bottom of the page.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '136bd57d-dfc4-47ad-8b6c-0689a0f0e429',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 6',
    sentence: 'Okay, so I go to bookmark down here.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '381b8448-b9ee-43db-b274-b915b4b4eaf9',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 6',
    sentence: "I'll click bookmark and I would sign up then I guess.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9829,
    sentimentByParticipant: 0,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '74304dea-6568-489d-8d4b-bf4f62094b59',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 7',
    sentence: "So I'm back from my meeting and I want to find the article that I book marked.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '31245108-2b3a-4831-9f6e-74f5aaa599d8',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 7',
    sentence: 'This is my account settings.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'c13b534a-1cb6-40b2-8b8c-94b05e25c1ec',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 7',
    sentence: "I would assume so I could post a story not sure if the medium partner program is but it says bookmarks and now I see all the different things that I've bookmarked.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: '2fbf2e0f-9937-4a3d-bfc7-abd7fffe0d91',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: "So to look for that bookmark article, I'm going to scroll to the footer.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '88dc833f-f0ce-4f05-9d93-d33c30dbc204',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: "And I don't think I can get there because the articles are just in a feed.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '751927c4-25c7-4dfd-b9be-09933048038e',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: 'So I go up to the top.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '8c745f0d-3201-425a-aec2-390ba64283d6',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: "I'm going to click on that icon with my initial in it and then look for bookmarks.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '3a87c274-45c6-48a9-a555-e8b077e690db',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 7',
    sentence: 'And I found that exact article.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: -0.5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '9d9c466a-f2c4-406c-a9e1-6922b2faf94c',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 7',
    sentence: 'Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0.6,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '9f42d301-e51c-498d-bb87-1c3189d8a958',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 7',
    sentence: "So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that.",
    important: true,
    removed: false,
    sentimentBySentence: 'Positive',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0.6,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '8794c104-05d4-461c-b507-365a062c92d3',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 7',
    sentence: "I mean, I'm not sure how much it costs but I did like that.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.9701,
    sentimentByParticipant: 0.6,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'b1b0b9a3-92a7-48fc-8c61-1d61a5ac4c52',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: "So now I'm looking for a Twitter icon and I see it on the side of the panel.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '3014a884-be39-402d-a48f-5e755f8d84fe',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: 'I kind of wish it was it stood out a little more because the icons are all black.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: '8153df05-7a08-4abf-831c-28e62a7da3bf',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: "So it maybe it'd be nice to just have an outline.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'd6a4b396-6e16-4ba1-9d18-9fb4d8058cec',
    testerId: '09a7adec-b51a-4305-bbef-973092fd7868',
    questionGroupName: 'Task 8',
    sentence: "That's the Twitter color and an outline of the Facebook.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: -0.5,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quoteId: 'f94deea1-0fa5-49c8-89dd-53c51f7310b1',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: 'Go back to this article.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '4412f30a-a3c8-4d8f-93fc-f1dcb1a8d503',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: 'So right underneath the book Mark page, there is a Twitter icon.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: '27332e3e-3d2a-48c2-ba6f-e574390e0fb4',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: "So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'a62dc60e-9096-4cf4-9d66-ec734f0dd589',
    testerId: '7150236a-457c-45c7-8f33-a2933ab3cc69',
    questionGroupName: 'Task 8',
    sentence: 'So I would just click login and tweet.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0.6,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quoteId: 'cf26fa3d-b565-414b-bcb2-602d20b4d0e3',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 8',
    sentence: "So if I want to share this article on Twitter, I would look so it's as soon as I explore all down.",
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'e55e21c8-1b73-4a04-b8c0-128311e54a28',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 8',
    sentence: 'I see the social icons.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quoteId: 'd30fdaa3-a1b5-4ff1-adc1-0717eaf4199d',
    testerId: '248ed906-bb4f-40cd-8584-f55d5dedb9e3',
    questionGroupName: 'Task 8',
    sentence: 'So I put Twitter and I shared on Twitter then.',
    important: false,
    removed: false,
    sentimentBySentence: 'Neutral',
    sentimentByTask: 0.855,
    sentimentByParticipant: 0,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }],
};

export const analyticsQuoteData = {
  quotesKeys: [{
    quotesKeyId: '7e20f084-3fed-4afa-bf86-1c00647f3099',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "This looks like a page where I could read articles. It looks like there are a ton of different categories that are all these different headers. It looks like they're featured articles that are being shown up top.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c1f28df1-5489-424f-8c26-ac302e0bc9db',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "This looks like a page where I could read articles. It looks like there are a ton of different categories that are all these different headers. It looks like they're featured articles that are being shown up top.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '986e2b86-df5c-4488-8759-8111d95e5000',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "This looks like a page where I could read articles. It looks like there are a ton of different categories that are all these different headers. It looks like they're featured articles that are being shown up top.",
    keyword: 'different',
    keywordCount: 7,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '3525ccb6-9251-4069-92c5-fa8b82e0d837',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "It looks like there are a ton of different categories that are all these different headers. It looks like they're featured articles that are being shown up top. And it looks like I could sign up for these articles.",
    keyword: 'top',
    keywordCount: 7,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'a152aff6-c796-4789-a017-ff004ca3be87',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "It looks like there are a ton of different categories that are all these different headers. It looks like they're featured articles that are being shown up top. And it looks like I could sign up for these articles.",
    keyword: 'sign',
    keywordCount: 5,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2fcc19b1-b706-4d15-ab14-9356b90ad94e',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "This looks like a page where I could read articles. It looks like there are a ton of different categories that are all these different headers. It looks like they're featured articles that are being shown up top.",
    keyword: 'read article',
    keywordCount: 3,
    videoTime: 4906,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '678fb35d-5a0a-4e91-91c9-fab653516e41',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "So I think the design looks clean. I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '749f2b4b-3cc9-443b-a5c7-d4e9a721283b',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'bb5eef2a-b67c-4ddb-9b66-cabc75c1f8a1',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '30abdb8e-8ad4-4042-80e4-e6cacfe98534',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '860d5a98-fe16-4fea-98c9-d20e59ce080f',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '318f6d62-f8e2-490c-9462-24988a944812',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    keyword: 'different',
    keywordCount: 7,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'faabd3f9-e88e-484d-8aae-23724f34b21c',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "So I think the design looks clean. I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is.",
    keyword: 'easy',
    keywordCount: 6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '62ac1ca9-22d5-47d4-916a-da6166a6971f',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    keyword: 'easy',
    keywordCount: 6,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '12daa0db-1c08-4dfe-9c28-9146feb01f72',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "So I think the design looks clean. I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is.",
    keyword: 'design',
    keywordCount: 4,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7730d69d-045e-4d96-b80e-9ca878b49bf3',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "So I think the design looks clean. I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is.",
    keyword: 'simple',
    keywordCount: 3,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '332f253c-2b37-4499-b216-6766f004eecd',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I really like how everything is really really simple and the only colors that they have are the colors of the Articles of the photo in the article and it seems really easy to find what I'm looking for because there's not big call to actions or anything like that. I really like how simple it is. You just see the article and you can just look at the title and see if that's something of Interest.yeah, it's it's a source for all articles written by all different types of people and there's different categories and it's very easy to you know, read in articles that you find interesting.",
    keyword: 'simple',
    keywordCount: 3,
    videoTime: 5085,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'cfcdeb7b-5463-429c-befb-222a3d8bc70a',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I'm looks like I can sign up for it. I feel pretty overwhelmed because there's a lot going on at this top. I'm not really sure there seems like there's three columns of stories that are different heights and widths I guess they're the featured stories, but it's a little overwhelming and my eyes really aren't drawn to anything but it looks like I can read a bunch of Articles and view stories.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'fde7b4f5-f115-499c-9a19-13c1abd53e6d',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I'm looks like I can sign up for it. I feel pretty overwhelmed because there's a lot going on at this top. I'm not really sure there seems like there's three columns of stories that are different heights and widths I guess they're the featured stories, but it's a little overwhelming and my eyes really aren't drawn to anything but it looks like I can read a bunch of Articles and view stories.",
    keyword: 'different',
    keywordCount: 7,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b17995eb-d1da-43d3-a80e-50c9b63fc10b',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "I'm looks like I can sign up for it. I feel pretty overwhelmed because there's a lot going on at this top. I'm not really sure there seems like there's three columns of stories that are different heights and widths I guess they're the featured stories, but it's a little overwhelming and my eyes really aren't drawn to anything but it looks like I can read a bunch of Articles and view stories.",
    keyword: 'top',
    keywordCount: 7,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '26964ab2-3bda-4812-bc08-ecb61cd18e57',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '42026b53-b202-22fc-0a49-ff58d508601c',
    questionGroupName: 'Task 1',
    threeSentences: "Looks like it posts a bunch of stories and articles. I'm looks like I can sign up for it. I feel pretty overwhelmed because there's a lot going on at this top.",
    keyword: 'sign',
    keywordCount: 5,
    videoTime: 8471,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b218a75b-714b-4a00-99ae-d8bdc535ab6d',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "On this website seems trustworthy. It seems a little Bland with white background and black text but it does seem trustworthy. I'm I've heard of this brand before and it looks like a ton of people right for them.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '0a63a3d6-0295-4129-8ee6-aa82bf151e5c',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "On this website seems trustworthy. It seems a little Bland with white background and black text but it does seem trustworthy. I'm I've heard of this brand before and it looks like a ton of people right for them.",
    keyword: 'right',
    keywordCount: 5,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '116f999d-c5de-4546-8b21-d87b4ea741fc',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "On this website seems trustworthy. It seems a little Bland with white background and black text but it does seem trustworthy. I'm I've heard of this brand before and it looks like a ton of people right for them.",
    keyword: 'trustworthy',
    keywordCount: 4,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '022b212e-0515-481f-89ca-f8d1f56ceba3',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "On this website seems trustworthy. It seems a little Bland with white background and black text but it does seem trustworthy. I'm I've heard of this brand before and it looks like a ton of people right for them.",
    keyword: 'trustworthy',
    keywordCount: 4,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '1a70be0c-8106-490f-85c0-e08928d4809c',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "On this website seems trustworthy. It seems a little Bland with white background and black text but it does seem trustworthy. I'm I've heard of this brand before and it looks like a ton of people right for them.",
    keyword: 'white background',
    keywordCount: 2,
    videoTime: 23983,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2cf613ce-d1f4-47e2-ba03-4090834493fe',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I have this is website looks very trustworthy. I feel like it looks very professional and I wouldn't I would like to read a lot of articles on here. I don't see any ads.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'd77cdf59-1c62-4e3d-8dfc-9d59fffdb723',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'e03484c4-11a4-4a01-b766-9d1fa424188e',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '58475d1d-1792-4acb-bfc7-ffb451cf6278',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I have this is website looks very trustworthy. I feel like it looks very professional and I wouldn't I would like to read a lot of articles on here. I don't see any ads.",
    keyword: 'trustworthy',
    keywordCount: 4,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '020c0fd0-f5d9-4eea-8dc8-3d8232d3d2c4',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    keyword: 'trustworthy',
    keywordCount: 4,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'ebf60aee-6e25-44fe-8dc9-791de9234f29',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    keyword: 'many',
    keywordCount: 3,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '572dc3ca-f7cb-473f-815a-521b9ccd1491',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    keyword: 'many',
    keywordCount: 3,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '3cf5a00c-91df-43d6-ae16-fb46e4d32392',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    keyword: 'many ad',
    keywordCount: 2,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '030ba6b8-499b-4bcf-a171-be98ba074737',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I don't see any ads. So I like how that it doesn't look like there's too many ads on on the page. Sometimes when you see websites with too many ads, they don't feel trustworthy but this feels trustworthy because he doesn't have any ads and it's just focused on the content and not on trying to serve you so many ads.",
    keyword: 'many ad',
    keywordCount: 2,
    videoTime: 70413,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '074cf98a-1e6b-44e2-81bf-621829c6e9a1',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I mean I wouldn't on not trust it but it's also not doesn't look that nice especially with the white background and just black font. It's it doesn't seem like a lot of But overall I think I would trust it. I probably wouldn't put it credit card information in but I trust it.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '049daf88-63fb-4a1e-b66e-167ab21b386c',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '80eb02dc-b36d-d039-e020-a6e772aaed85',
    questionGroupName: 'Task 2',
    threeSentences: "I mean I wouldn't on not trust it but it's also not doesn't look that nice especially with the white background and just black font. It's it doesn't seem like a lot of But overall I think I would trust it. I probably wouldn't put it credit card information in but I trust it.",
    keyword: 'white background',
    keywordCount: 2,
    videoTime: 56316,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '0d6f40b9-3687-43f1-9a4e-2f05efdb1661',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "Well, maybe it's design click on design. And I'm looking at related topics and says ux here. Now I have on a landing page.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'd2821446-56a4-44d5-ba1a-7d06a164e8ff',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "If I want to view articles about ux, I think I would click on. None of these categories really show you X so I'm going to click more. I'm going to scroll through so I don't think it's arts and entertainment.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b7ba8450-ec09-4ff7-bcc9-60dc257b1871',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "If I want to view articles about ux, I think I would click on. None of these categories really show you X so I'm going to click more. I'm going to scroll through so I don't think it's arts and entertainment.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '49f0d959-0f30-4ab0-9ce8-b59da2c9d6ad',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So it's not an industry, which is a little weird. Well, maybe it's design click on design. And I'm looking at related topics and says ux here.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '6d8bc82b-6efc-45bc-ae31-b8207c70b960',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "And I'm looking at related topics and says ux here. Now I have on a landing page. Now I have on a landing page.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2226f0e5-a641-47c7-9eb0-8952b42aa214',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "And I'm looking at related topics and says ux here. Now I have on a landing page. Now I have on a landing page.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'd2f02d88-c6c8-4f04-885f-2a301c2915a3',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "And I'm looking at related topics and says ux here. Now I have on a landing page. Now I have on a landing page.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '40b05a7a-9d77-4049-9720-7040d72c17bf',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "And I'm looking at related topics and says ux here. Now I have on a landing page. Now I have on a landing page.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7582f707-6f57-46d1-ab9e-f4600cd11637',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "If I want to view articles about ux, I think I would click on. None of these categories really show you X so I'm going to click more. I'm going to scroll through so I don't think it's arts and entertainment.",
    keyword: 'want',
    keywordCount: 5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'ec29a08f-6420-451d-a337-f5fed13a4c9d',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "None of these categories really show you X so I'm going to click more. I'm going to scroll through so I don't think it's arts and entertainment. So it's not an industry, which is a little weird.",
    keyword: 'scroll',
    keywordCount: 5,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'a45b42aa-b35b-450b-ab0c-6cefe8d40923',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So it's not an industry, which is a little weird. Well, maybe it's design click on design. And I'm looking at related topics and says ux here.",
    keyword: 'design',
    keywordCount: 4,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '78bd2ca9-b494-4dbb-a8ae-c60cbf5cdb81',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "I'm going to scroll through so I don't think it's arts and entertainment. So it's not an industry, which is a little weird. Well, maybe it's design click on design.",
    keyword: 'weird',
    keywordCount: 4,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '0cc26872-d7bc-4124-a188-0310624a5b33',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "If I want to view articles about ux, I think I would click on. None of these categories really show you X so I'm going to click more. I'm going to scroll through so I don't think it's arts and entertainment.",
    keyword: 'view article',
    keywordCount: 2,
    videoTime: 41446,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'd562389e-a186-4df8-bfa5-9f7c41f20f1c',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux. Right and here right away. I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b963ce68-81bf-4e4d-86ee-f07e5c29ae57',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux. Right and here right away. I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '580c25dc-6a35-4337-9603-3a53c21d7322',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: 'Right and here right away. I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice. So I like that I see a lot of content on ux and I also see on the right hand side tags.',
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '9bd18e18-c918-4282-a0c0-7f45ac4883d5',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: 'I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice. So I like that I see a lot of content on ux and I also see on the right hand side tags. And each of these I could the first thing is you asked which is exactly what I searched for.',
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '8426709d-f52b-471a-8728-2038a93b63c9',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: 'And each of these I could the first thing is you asked which is exactly what I searched for. But I like how it also has the other related term to let other related keywords that may be associated with ux. So design user experience UI so I like that had suggest options for me.',
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '79c9b1cc-b1d7-4d82-b851-afc7f881f75b',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "That's really nice and also suggest people that I could read. So these are kind of trusted sources I would say I would think that they are people who write about ux so I like that a lot as well as publication. So yeah like this is very easy.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '965106ae-838b-4a1d-9f75-a60b4ef034b9',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So design user experience UI so I like that had suggest options for me. That's really nice and also suggest people that I could read. So these are kind of trusted sources I would say I would think that they are people who write about ux so I like that a lot as well as publication.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2fccebd1-a57c-4399-af45-a598b7caec57',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So design user experience UI so I like that had suggest options for me. That's really nice and also suggest people that I could read. So these are kind of trusted sources I would say I would think that they are people who write about ux so I like that a lot as well as publication.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'f384df47-88dc-4ecf-b710-664375a6894c',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "That's really nice and also suggest people that I could read. So these are kind of trusted sources I would say I would think that they are people who write about ux so I like that a lot as well as publication. So yeah like this is very easy.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b0b69156-dfc3-4172-88c3-d14827066150',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "That's really nice and also suggest people that I could read. So these are kind of trusted sources I would say I would think that they are people who write about ux so I like that a lot as well as publication. So yeah like this is very easy.",
    keyword: 'easy',
    keywordCount: 6,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7544b4c0-bac1-4a94-87f4-48808c5d91b3',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux. Right and here right away. I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.",
    keyword: 'sign',
    keywordCount: 5,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b468db96-13e6-4d2b-9663-28cb42d63c5d',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux. Right and here right away. I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.",
    keyword: 'right',
    keywordCount: 5,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '0afcbd61-4384-40ce-87f2-e90b692dea50',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: 'I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice. So I like that I see a lot of content on ux and I also see on the right hand side tags. And each of these I could the first thing is you asked which is exactly what I searched for.',
    keyword: 'right',
    keywordCount: 5,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2c186ecb-3c11-4bf4-ba18-743bd685ad44',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "But I like how it also has the other related term to let other related keywords that may be associated with ux. So design user experience UI so I like that had suggest options for me. That's really nice and also suggest people that I could read.",
    keyword: 'design',
    keywordCount: 4,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c78a478e-70bf-4f06-b5f1-67da31bf3ff2',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux. Right and here right away. I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.",
    keyword: 'search',
    keywordCount: 4,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '506ade69-7569-4def-824e-22014e10ca0b',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So that's fine article on ux I would so I would sign in first here so that it sends me in and then I would go to the search bar and just write ux. Right and here right away. I see multiple articles on ux and I can keep scrolling down and looks like they have a lot of articles on ux which is really nice.",
    keyword: 'search bar',
    keywordCount: 2,
    videoTime: 108567,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'abfa72b5-67cf-4e5a-b631-57bdd986e78a',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So if I want to view articles about ux I look at the top. Portion here, so I can't find anything that says ux or design. Okay, so I accidentally put become a member.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '88a12bb6-98a0-4b93-9d93-0b6c6b69d95c',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So if I want to view articles about ux I look at the top. Portion here, so I can't find anything that says ux or design. Okay, so I accidentally put become a member.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '1fa65ed9-ad0c-4112-9eea-0ee50d9dc6fb',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "I thought that this become member was sort of in the search bar. So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'f04ee4f1-522b-4dd3-8fb5-8321bbe6e088',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So if I want to view articles about ux I look at the top. Portion here, so I can't find anything that says ux or design. Okay, so I accidentally put become a member.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '61026a6e-9b77-4303-a623-7caf96f18f1b',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "I thought that this become member was sort of in the search bar. So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'e9fa7dd5-3a26-4173-b321-3a312705321e',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "I thought that this become member was sort of in the search bar. So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '43fc98eb-bf45-40fe-9626-c00d6fa99f10',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here. So now I have this giant search don't think those very intuitive but that makes sense.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '31790f86-84f7-405e-92f6-b425e78e1762',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here. So now I have this giant search don't think those very intuitive but that makes sense.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '9a62d4c0-9295-4123-a799-f87b5e06ba04',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So if I want to view articles about ux I look at the top. Portion here, so I can't find anything that says ux or design. Okay, so I accidentally put become a member.",
    keyword: 'top',
    keywordCount: 7,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'e86e5dc3-b794-4d74-bad1-9a9bbd5e6996',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So if I want to view articles about ux I look at the top. Portion here, so I can't find anything that says ux or design. Okay, so I accidentally put become a member.",
    keyword: 'want',
    keywordCount: 5,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '50dc9d22-b880-4349-b379-8f0a1205c0e7',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So if I want to view articles about ux I look at the top. Portion here, so I can't find anything that says ux or design. Okay, so I accidentally put become a member.",
    keyword: 'design',
    keywordCount: 4,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'e3cf3059-6cc1-456a-9d68-b8014af11d14',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "Okay, so I accidentally put become a member. I thought that this become member was sort of in the search bar. So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications.",
    keyword: 'search',
    keywordCount: 4,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '95033c4a-7f0f-489d-9fb1-c50f162ca341',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "I thought that this become member was sort of in the search bar. So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here.",
    keyword: 'search',
    keywordCount: 4,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '1b8029ba-7273-4e98-9137-d3b302721245',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications. I'm not really sure the difference between people and Publications because I see the same icon here. So now I have this giant search don't think those very intuitive but that makes sense.",
    keyword: 'search',
    keywordCount: 4,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c9939d74-24e9-4bdf-9206-c844092eb0ec',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "Okay, so I accidentally put become a member. I thought that this become member was sort of in the search bar. So let me just pick that small search I would search ux and then I go and so I guess I see people I guess I'll look at Publications.",
    keyword: 'search bar',
    keywordCount: 2,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2e401ee4-80cb-46d9-a0a4-679e0226f7b9',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1cd33a3c-9660-a124-c3b9-e1410dfe50c1',
    questionGroupName: 'Task 3',
    threeSentences: "So if I want to view articles about ux I look at the top. Portion here, so I can't find anything that says ux or design. Okay, so I accidentally put become a member.",
    keyword: 'view article',
    keywordCount: 2,
    videoTime: 89888,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '32183125-7197-4a89-a46e-82fd28b82f4d',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It doesn't really make sense because you X is in a user. It's a industry so I can see the latest articles and then there's some featured writers. I think I could read articles about ux and some of these images look a little weird.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '23851e3a-8490-4508-b201-ead0826a9762',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It doesn't really make sense because you X is in a user. It's a industry so I can see the latest articles and then there's some featured writers. I think I could read articles about ux and some of these images look a little weird.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '577b1209-9937-4a26-a581-163505be9a20',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It doesn't really make sense because you X is in a user. It's a industry so I can see the latest articles and then there's some featured writers. I think I could read articles about ux and some of these images look a little weird.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '579efde6-1c20-4519-8ad4-67b0c3314a32',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "My impression is that I could this page is that there are ton of Articles here. It looks like I could follow this entire category. It's weird that it says all about that user.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'fa44e9db-42e9-4177-96e5-753567e33cdd',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It looks like I could follow this entire category. It's weird that it says all about that user. It doesn't really make sense because you X is in a user.",
    keyword: 'weird',
    keywordCount: 4,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '01dba672-da21-4fd6-9448-206b800fd331',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It doesn't really make sense because you X is in a user. It's a industry so I can see the latest articles and then there's some featured writers. I think I could read articles about ux and some of these images look a little weird.",
    keyword: 'weird',
    keywordCount: 4,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '96b82326-f9f5-4b05-b43d-56fae9a430b8',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It doesn't really make sense because you X is in a user. It's a industry so I can see the latest articles and then there's some featured writers. I think I could read articles about ux and some of these images look a little weird.",
    keyword: 'read article',
    keywordCount: 3,
    videoTime: 96739,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'f1675ecd-9f21-4463-8975-5be8b075af17',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice. So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article. So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '97e861ff-b90a-458f-a761-2999ae2e5313',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice. So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article. So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'eadd3418-771f-4b9f-baab-386b8a5e89cd',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice. So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article. So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'dfb528d2-d6d2-47e7-95cc-346e6ff7964b',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice. So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article. So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'fced2962-6c98-43b6-acc8-2913527532f7',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice. So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article. So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '6ff2a235-e4cb-4fe3-8aea-93ee0bee0bd8',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "It's my first impression of this page is that it focuses on the content it focuses on just exactly what I searched for and it's it gives me a little bit of like I can see who responded to this article which is really nice. So I haven't seen that before in other Publications or other websites like this or I can see a hundred seventy seven people responded to this article which means it's being talked about a lot as well as there's the Clapping hands which means that a lot of people like this article. So, you know, I like how it shows me the ones that are really popular which I'm assuming in the ones that are worth my time to read so I like I like how its structured for that purpose.",
    keyword: 'time',
    keywordCount: 3,
    videoTime: 210469,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c7683a73-a82d-41b1-8fb5-fb80f02d0c97',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "I mean there's a lot. Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands. I can see how many people commented on it and how long it takes to read and who it was from.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '32239e30-66b2-4d33-8ef7-cc3d6e741de1',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "I can see how many people commented on it and how long it takes to read and who it was from. I don't know the difference between like ux and motion for ux Planet first prototype. I don't know if those are different companies that are just publishing.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '467c1b1d-0126-40d7-bce6-b4f3a1a8dc43',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "I mean there's a lot. Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands. I can see how many people commented on it and how long it takes to read and who it was from.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'f6cb5416-3fe6-49a3-9b9c-bf231189b6ae',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands. I can see how many people commented on it and how long it takes to read and who it was from. I don't know the difference between like ux and motion for ux Planet first prototype.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'f5c53d9a-abe2-467b-bf1c-22963f24b3a2',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "So on this page my impression is that it's pretty standard. I mean there's a lot. Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '19094866-1e1c-4c88-8cd7-010fcb79b591',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands. I can see how many people commented on it and how long it takes to read and who it was from. I don't know the difference between like ux and motion for ux Planet first prototype.",
    keyword: 'people',
    keywordCount: 8,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'a542f85a-9297-4fe1-9bc7-7788add2559c',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "I don't know the difference between like ux and motion for ux Planet first prototype. I don't know if those are different companies that are just publishing. Information or if they're just different like segments of the article, so I'm a little confused on that.",
    keyword: 'different',
    keywordCount: 7,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c726db75-d15b-46bb-8eb4-190ab04ab8ad',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "I don't know the difference between like ux and motion for ux Planet first prototype. I don't know if those are different companies that are just publishing. Information or if they're just different like segments of the article, so I'm a little confused on that.",
    keyword: 'different',
    keywordCount: 7,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b7a22108-1215-4002-b7d7-99d547d63017',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands. I can see how many people commented on it and how long it takes to read and who it was from. I don't know the difference between like ux and motion for ux Planet first prototype.",
    keyword: 'many',
    keywordCount: 3,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '4bbeaeea-ea4c-4aee-bc05-b5988aee5967',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '1e7c311d-f3f0-0bcf-2eed-8442fc714a2e',
    questionGroupName: 'Task 4',
    threeSentences: "I mean there's a lot. Like this catches my eye the fact that there's Motion in one of these titles not sure that I like that very much but I know that I can read articles about ux I could upvote them essentially by clicking on the hands. I can see how many people commented on it and how long it takes to read and who it was from.",
    keyword: 'read article',
    keywordCount: 3,
    videoTime: 157731,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'ad3bde39-02b0-4eb2-bce3-e7fb771084dc',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I'm not really sure what ux collected means or the startup. I don't know if these are companies or just segments of different verticals within medium, but here's a six-minute article. So I'm going to click on that.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '25a2b363-0de7-4a43-b45e-7c22c8fe2ba4',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I think it's a little weird. I'm not really sure what ux collected means or the startup. I don't know if these are companies or just segments of different verticals within medium, but here's a six-minute article.",
    keyword: 'ux',
    keywordCount: 13,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7d42a581-8ab6-47c6-aac0-ba136051b1a7',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "It's really easy to see that here. I could see the title a little description the person and the date and then number of minutes to read. I think it's a little weird.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '423dfb7b-c668-4e3e-b65a-8f259a6719b1',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I'm not really sure what ux collected means or the startup. I don't know if these are companies or just segments of different verticals within medium, but here's a six-minute article. So I'm going to click on that.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '126f4e8f-4142-4ce8-9ae7-c4efd0d879f2',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I'm not really sure what ux collected means or the startup. I don't know if these are companies or just segments of different verticals within medium, but here's a six-minute article. So I'm going to click on that.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'f16fdd49-fce5-4e65-8765-be528b4a66c4',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I'm not really sure what ux collected means or the startup. I don't know if these are companies or just segments of different verticals within medium, but here's a six-minute article. So I'm going to click on that.",
    keyword: 'different',
    keywordCount: 7,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '096924fe-0302-451e-ae33-09dc3e0a7445',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "so if I'm looking for something that's around 6 minutes. It's really easy to see that here. I could see the title a little description the person and the date and then number of minutes to read.",
    keyword: 'easy',
    keywordCount: 6,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '525744db-3efc-4c98-96f9-d22ccd1f6114',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I could see the title a little description the person and the date and then number of minutes to read. I think it's a little weird. I'm not really sure what ux collected means or the startup.",
    keyword: 'weird',
    keywordCount: 4,
    videoTime: 141816,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'a15c4108-66ff-4f11-8f82-335c706af5bd',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: " Okay, so at the top next to the person's name, it says the amount of time that the article is so I'm not seeing specifically six minutes, but I do see other length articles so I know that it I know where to find. I just am not finding. So I found this article redesigning the New York Times app you ask a study.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '77d2317d-7f3c-4827-9ce2-52cef64bb924',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: 'I just am not finding. So I found this article redesigning the New York Times app you ask a study. So I would click on that header here and that would open.',
    keyword: 'article',
    keywordCount: 13,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '0d357d0c-74a6-4f04-ae72-47f328826b63',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: 'I just am not finding. So I found this article redesigning the New York Times app you ask a study. So I would click on that header here and that would open.',
    keyword: 'click',
    keywordCount: 11,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'dbd63525-35e5-4f8f-a4e4-23722bed2c83',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: " Okay, so at the top next to the person's name, it says the amount of time that the article is so I'm not seeing specifically six minutes, but I do see other length articles so I know that it I know where to find. I just am not finding. So I found this article redesigning the New York Times app you ask a study.",
    keyword: 'top',
    keywordCount: 7,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '80fa4c67-cfc5-4f7a-95b9-111ecfefcf4b',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: " Okay, so at the top next to the person's name, it says the amount of time that the article is so I'm not seeing specifically six minutes, but I do see other length articles so I know that it I know where to find. I just am not finding. So I found this article redesigning the New York Times app you ask a study.",
    keyword: 'time',
    keywordCount: 3,
    videoTime: 261173,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '27e43ded-4da8-45d0-894c-f9855b19e1b7',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "So I'm about to run off to a meeting. I would look for something that is six minutes and okay, so I see one that's five minutes. I see the five minutes up by the top of it.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'cecb9823-713a-4d6d-836c-86487ba0b7d5',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I this is there's a huge disconnect between the picture with the person's name and the date and also the title, so I was a little confused on that. but So I see this one that is five minutes. So I'm going to click on that.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'dae3c6d0-578d-4299-9bcb-701e7750d0e3',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I this is there's a huge disconnect between the picture with the person's name and the date and also the title, so I was a little confused on that. but So I see this one that is five minutes. So I'm going to click on that.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c6ff9875-0d81-4677-8c80-bad3c8c1509d',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '73ee35ff-e127-c24b-7bfe-61980f030fbf',
    questionGroupName: 'Task 5',
    threeSentences: "I would look for something that is six minutes and okay, so I see one that's five minutes. I see the five minutes up by the top of it. I this is there's a huge disconnect between the picture with the person's name and the date and also the title, so I was a little confused on that.",
    keyword: 'top',
    keywordCount: 7,
    videoTime: 204386,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '71587740-e863-46ac-96a7-1727ca971bd3',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I'm so I want to bookmark. This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '965c2886-2416-4853-93ab-6154d8f78290',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark. Okay, and now I'm going to sign in.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '4ee12d6c-7594-432f-bc60-546ab89c36d3',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I'm so I want to bookmark. This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '4e8ba5ee-aebc-4de7-8d4f-cb1ed82168ab',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I'm so I want to bookmark. This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b318d69d-53e9-4e72-95dc-a0a6fe4786d7',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '32949c27-9418-409a-997e-90b42b306d93',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark. Okay, and now I'm going to sign in.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '22f1abd8-60b4-4ad9-9497-1ba4c0f5ebe9',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I'm so I want to bookmark. This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '8d9041c4-b695-4ccf-a338-b099f048400e',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'f0957fdd-abc7-468f-82fa-2e2b7f8914ae',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark. Okay, and now I'm going to sign in.",
    keyword: 'sign',
    keywordCount: 5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'aca45a6b-581d-400e-8d2c-da5693e91645',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I'm so I want to bookmark. This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    keyword: 'want',
    keywordCount: 5,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7747170b-a40d-4b90-a610-b9dc44df10d8',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I'm so I want to bookmark. This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen.",
    keyword: 'bookmark icon',
    keywordCount: 2,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '586425ae-e65f-439b-9014-bd32b95e8030',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "This will look for a little bookmark icon. I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark.",
    keyword: 'bookmark icon',
    keywordCount: 2,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7b44b15f-fe8a-4190-a065-6f4746b6fb87',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "I thought was kind of annoying that little pop-up came up signing up, but it looks like there's that bookmark icon on the left side of the screen. I'm going to click bookmark. Okay, and now I'm going to sign in.",
    keyword: 'click bookmark',
    keywordCount: 2,
    videoTime: 184033,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '08c9dcf7-ac73-47ce-9551-bf146c69ea09',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'd52ec715-d68f-4a84-8886-48622ad6d2c9',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'dda19bd8-90fe-4238-beed-fc0d3bf724cc',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'ff54e826-1303-4625-b287-1f4449444cfd',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '08281fe0-7d1f-4541-8b53-ee09915c2bd0',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '523c4d45-5b29-4b03-867f-9ebb8dd43d0f',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess.",
    keyword: 'sign',
    keywordCount: 5,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '232b5acb-b8e9-4c72-9275-b94692a57f65',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "okay, so if I wanted to bookmark this let me see at the bottom of the page. Okay, so I go to bookmark down here. I'll click bookmark and I would sign up then I guess.",
    keyword: 'click bookmark',
    keywordCount: 2,
    videoTime: 272315,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'bd27280f-7d78-4a35-8ce1-9a14384d88df',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands. So that was pretty easy for me to do.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '99c27c02-59b5-4890-8936-1d28d75c9485',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands. So that was pretty easy for me to do.",
    keyword: 'page',
    keywordCount: 9,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '588d8d00-7eb3-4df1-a225-03d26cc11399',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands. So that was pretty easy for me to do.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '775b852f-b0e4-4a2b-bc1f-5dd6726c38a0',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands. So that was pretty easy for me to do.",
    keyword: 'top',
    keywordCount: 7,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '6e361a21-5adc-4718-9689-d7e993c1ebcc',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands. So that was pretty easy for me to do.",
    keyword: 'easy',
    keywordCount: 6,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'e4c080c6-0aad-4f48-8873-222d0f1891ce',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands. So that was pretty easy for me to do.",
    keyword: 'scroll',
    keywordCount: 5,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '3d0ddec7-c248-47fc-9a8b-4066d1dd2edc',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '103a97af-a516-2903-45dd-7e736b5cd2b9',
    questionGroupName: 'Task 6',
    threeSentences: "And so if I was to bookmark this page when I'm at the top here, I don't see any option to bookmark, but then it does pop up actually the option to bookmark when I scroll down so that's nice. So as I scroll down to see the option and it's a kind of save icon underneath the Clapping hands. So that was pretty easy for me to do.",
    keyword: 'scroll',
    keywordCount: 5,
    videoTime: 328808,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2a7dc5d0-317f-4e59-916b-8c60911933a5',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So to look for that bookmark article, I'm going to scroll to the footer. And I don't think I can get there because the articles are just in a feed. So I go up to the top.",
    keyword: 'scroll',
    keywordCount: 5,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '09f9be06-415c-49d2-92dc-26dfbb646feb',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So I go up to the top. I'm going to click on that icon with my initial in it and then look for bookmarks. And I found that exact article.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '8a5b9e06-ced6-4ec1-8d69-0e923e008e7a',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So to look for that bookmark article, I'm going to scroll to the footer. And I don't think I can get there because the articles are just in a feed. So I go up to the top.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '5d0c9908-16cc-4cf1-bb67-e367530082c3',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So I go up to the top. I'm going to click on that icon with my initial in it and then look for bookmarks. And I found that exact article.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c888bb21-d4e6-4577-a425-02ea7b4319f0',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So I go up to the top. I'm going to click on that icon with my initial in it and then look for bookmarks. And I found that exact article.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '28e9b458-7936-47a3-937c-7dc0aeaa339e',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So to look for that bookmark article, I'm going to scroll to the footer. And I don't think I can get there because the articles are just in a feed. So I go up to the top.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '6e132bb2-ab91-4d75-832c-06d7713a3913',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So I go up to the top. I'm going to click on that icon with my initial in it and then look for bookmarks. And I found that exact article.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '8c52d1b6-fdd7-450a-b45a-904cfed6500a',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "And I don't think I can get there because the articles are just in a feed. So I go up to the top. I'm going to click on that icon with my initial in it and then look for bookmarks.",
    keyword: 'top',
    keywordCount: 7,
    videoTime: 229486,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: '808603fc-948b-481e-b304-9536d3b03bb3',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So I'm back from my meeting and I want to find the article that I book marked. This is my account settings. I would assume so I could post a story not sure if the medium partner program is but it says bookmarks and now I see all the different things that I've bookmarked.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'd267ab28-b500-4430-bf3a-613d397d5396',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So I'm back from my meeting and I want to find the article that I book marked. This is my account settings. I would assume so I could post a story not sure if the medium partner program is but it says bookmarks and now I see all the different things that I've bookmarked.",
    keyword: 'different',
    keywordCount: 7,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '775047fe-7408-45a1-af24-3ce29a017830',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "So I'm back from my meeting and I want to find the article that I book marked. This is my account settings. I would assume so I could post a story not sure if the medium partner program is but it says bookmarks and now I see all the different things that I've bookmarked.",
    keyword: 'want',
    keywordCount: 5,
    videoTime: 331529,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'd6944157-09f9-4caf-bd1a-3bbe2768b020',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there. So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that. I mean, I'm not sure how much it costs but I did like that.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '60d233c0-ad79-4d53-885a-09de0a5f8080',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there. So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that. I mean, I'm not sure how much it costs but I did like that.",
    keyword: 'read',
    keywordCount: 11,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '013ed8c5-a7fd-41a2-af8d-fe778c2bae3c',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there. So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that. I mean, I'm not sure how much it costs but I did like that.",
    keyword: 'bookmark',
    keywordCount: 10,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '2b5f4a80-83f5-4832-8d41-2ec126d9126e',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there. So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that. I mean, I'm not sure how much it costs but I did like that.",
    keyword: 'easy',
    keywordCount: 6,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '1a65a9a9-4d41-4497-a01b-778d16624c99',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there. So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that. I mean, I'm not sure how much it costs but I did like that.",
    keyword: 'right',
    keywordCount: 5,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '502881bb-bddc-4a0d-9b6e-909ce6210080',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there. So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that. I mean, I'm not sure how much it costs but I did like that.",
    keyword: 'scroll',
    keywordCount: 5,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'b5cafaff-5706-4f6b-86b8-0f066a12a989',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: '411dc99c-f86b-f1eb-3011-89233e7ce52d',
    questionGroupName: 'Task 7',
    threeSentences: "Silver Surfer find that article I would go to my account settings and I would scroll down to my account settings and oh right there. So that's it's very easy and I see the first one is bookmarked is the one that I had just just showed what I like how it has this offline reading is here and I can choose to upgrade that's really nice because I do a lot of flying on the plane and I would like the option to bookmark things and save them for when I'm offline and I could read them at that time so that I like that option that gives me to do that. I mean, I'm not sure how much it costs but I did like that.",
    keyword: 'time',
    keywordCount: 3,
    videoTime: 370890,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'ec953cd0-24b0-4aa1-834c-3d8c3697bdba',
    testerId: 'a7d8f02d-b116-4b9b-a0e5-e5259dd8a13c',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So now I'm looking for a Twitter icon and I see it on the side of the panel. I kind of wish it was it stood out a little more because the icons are all black. So it maybe it'd be nice to just have an outline.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 264812,
    firstName: 'Mason',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'aaf9a576-5ec2-4a75-8963-2337ce9f4ee6',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "Go back to this article. So right underneath the book Mark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '28e7e87f-b408-4042-a9f4-787cc39e154a',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So right underneath the book Mark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple. So I would just click login and tweet.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'a85fb9a2-f552-4bf1-8c83-0c77984d6f30',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So right underneath the book Mark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple. So I would just click login and tweet.",
    keyword: 'click',
    keywordCount: 11,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7271b952-96b4-4237-bba3-bf3afac0df72',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "Go back to this article. So right underneath the book Mark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '9f3a971e-9386-4859-a858-4e4bc098c220',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So right underneath the book Mark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple. So I would just click login and tweet.",
    keyword: 'icon',
    keywordCount: 8,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '36d8d71f-ef16-4287-bd98-4556e0073896',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So right underneath the book Mark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple. So I would just click login and tweet.",
    keyword: 'simple',
    keywordCount: 3,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: 'c77c7fa9-fdf5-4878-b9e6-e1368988a3aa',
    testerId: '3e03230c-aaaa-4547-ab71-fddc1a50ec71',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "Go back to this article. So right underneath the book Mark page, there is a Twitter icon. So I would click on that Twitter icon and it suggests that week and it's actually already has me signed into my Twitter account, which is really simple.",
    keyword: 'right',
    keywordCount: 5,
    videoTime: 431203,
    firstName: 'Lance',
    lastName: 'Doe',
  }, {
    quotesKeyId: '97fa99ac-9e45-4f98-8cc4-c2b6dd39cffb',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So if I want to share this article on Twitter, I would look so it's as soon as I explore all down. I see the social icons. So I put Twitter and I shared on Twitter then.",
    keyword: 'article',
    keywordCount: 13,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '3d4f0817-cbf0-4461-9415-0563cd6aba82',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So if I want to share this article on Twitter, I would look so it's as soon as I explore all down. I see the social icons. So I put Twitter and I shared on Twitter then.",
    keyword: 'look',
    keywordCount: 11,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }, {
    quotesKeyId: '7fa60525-4e21-409f-9b6e-7730112669dd',
    testerId: 'e5fcb996-4b04-4690-8439-69b77bb2795d',
    questionGroupId: 'a6c1400e-2fe4-4855-ea4f-9eaa14bb82ab',
    questionGroupName: 'Task 8',
    threeSentences: "So if I want to share this article on Twitter, I would look so it's as soon as I explore all down. I see the social icons. So I put Twitter and I shared on Twitter then.",
    keyword: 'want',
    keywordCount: 5,
    videoTime: 371797,
    firstName: 'John',
    lastName: 'Doe',
  }],
};
